<template>
  <div class="perfectingInformation">
    <div class="detailedInformation">
      <el-form
        ref="ruleForm"
        :model="ruleForm.cooperInfoBO"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title :title="title" />
        <el-form-item
          class="remarkItem"
          label="单位名称（中文）："
          prop="supplierChineseName"
        >
          {{ ruleForm.cooperInfoBO.supplierChineseName }}
        </el-form-item>

        <el-form-item label="单位名称（英文）：">
          <el-input
            v-model="ruleForm.cooperInfoBO.supplierEnglishName"
            class="input-long"
            maxlength="300"
            onkeyup="this.value=this.value.replace(/[^A-Za-z0-9`~!@#$%^&*()_\-+=<>?:「」{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、\s+]/g,'');"
            placeholder="请输入单位名称（英文）"
          />
        </el-form-item>

        <el-form-item label="单位简称：" prop="supplierShortname">
          <el-input
            v-model="ruleForm.cooperInfoBO.supplierShortname"
            placeholder="请输入单位简称"
            class="input-short"
            maxlength="30"
            :disabled="isSid"
          ></el-input>
        </el-form-item>

        <el-form-item
          ref="unifiedCode"
          class="remarkItem unifiedCode"
          label="统一社会信用代码："
          prop="unifiedCode"
        >
          <div class="mustInfo">*</div>
          <el-input
            maxlength="18"
            ref="unifiedCode"
            @blur="unifiedCodeBlur"
            @input="checkUnifiedCode"
            v-model="ruleForm.cooperInfoBO.unifiedCode"
            class="input-short"
            placeholder="请输入统一社会信用代码"
          />
          <span class="codeTip2">
            如无统一社会信用代码
            <br />须填写工商注册号、组织机构代码、纳税人识别号
          </span>
        </el-form-item>

        <el-form-item
          ref="regNum"
          label="工商注册号："
          prop="regNum"
          class="remarkItem unifiedCode regNum"
        >
          <div class="mustInfoG">*</div>
          <el-input
            maxlength="15"
            @blur="regNumBlur"
            ref="regNum"
            v-model="ruleForm.cooperInfoBO.regNum"
            @input="checkRegNum"
            class="input-short"
            placeholder="请输入工商注册号"
          />
        </el-form-item>

        <el-form-item
          ref="orgCode"
          label="组织机构代码："
          prop="orgCode"
          class="remarkItem unifiedCode orgCode"
        >
          <div class="mustInfoT">*</div>
          <el-input
            maxlength="9"
            @blur="orgCodeBlur"
            ref="orgCode"
            @input="checkOrgCode"
            v-model="ruleForm.cooperInfoBO.orgCode"
            class="input-short"
            placeholder="请输入组织机构代码"
          />
        </el-form-item>

        <el-form-item
          ref="taxCode"
          label="纳税人识别号："
          prop="taxCode"
          class="remarkItem unifiedCode taxCode"
        >
          <div class="mustInfoT">*</div>
          <el-input
            maxlength="20"
            @blur="taxCodeBlur"
            ref="taxCode"
            @input="checkTaxCode"
            v-model="ruleForm.cooperInfoBO.taxCode"
            class="input-short"
            placeholder="请输入纳税人识别号"
          />
        </el-form-item>

        <el-form-item label="纳税人类型：" prop="taxpayerId">
          <el-select
            value="ruleForm.cooperInfoBO.taxpayerName"
            @visible-change="visibleChangeTax"
            @change="changeSle"
            v-model="ruleForm.cooperInfoBO.taxpayerName + ''"
            placeholder="请选择纳税人类型"
          >
            <!-- <el-option label="一般纳税人" value="general"></el-option>
            <el-option label="小规模纳税人" value="general2"></el-option>
            <el-option label="营业税纳税人" value="general3"></el-option>-->
            <el-option
              v-for="item in taxerList"
              :label="item.dicValue"
              :value="item.dicKey"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="住所：" prop="address">
          <el-input
            v-model="ruleForm.cooperInfoBO.address"
            class="input-short"
            placeholder="请输入住所"
            maxlength="200"
          />
        </el-form-item>

        <el-form-item label="公司类型：" prop="compType">
          <el-select
            value="ruleForm.cooperInfoBO.compTypeName"
            @visible-change="visibleChangeGslx"
            v-model="ruleForm.cooperInfoBO.compTypeName + ''"
            @change="changeCompany"
            placeholder="请选择公司类型"
          >
            <!--            <el-option label="有限责任公司" value="compType1"></el-option>-->
            <!--            <el-option label="股份有限公司" value="compType2"></el-option>-->
            <!--            <el-option label="其他股份有限公司(非上市)" value="compType2"></el-option>-->
            <el-option
              v-for="(item, idx) in codeList"
              :key="idx"
              :label="item.dicValue"
              :value="item.dicKey"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="成立日期：" prop="foundTime">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.cooperInfoBO.foundTime"
            type="date"
            placeholder="请选择成立日期"
            class="selectDate"
            style="width: 430px"
            :picker-options="{
              disabledDate: (time) => {
                return time.getTime() > Date.now();
              },
            }"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="注册资本（万元）：" prop="regCapl">
          <el-input
            v-model="ruleForm.cooperInfoBO.regCapl"
            class="input-short"
            placeholder="请输入注册资本（万元）"
            maxlength="15"
            @keydown.native="regCapitalChange"
          />
        </el-form-item>

        <el-form-item label="实收资本（万元）：">
          <el-input
            v-model="ruleForm.cooperInfoBO.factCapl"
            @input="checkFactCapl"
            class="input-short"
            placeholder="请输入实收资本（万元）"
            maxlength="15"
            @keydown.native="factCapitalChange"
          />
        </el-form-item>

        <el-form-item label="经营范围：" prop="supplierScope">
          <el-input
            v-model="ruleForm.cooperInfoBO.supplierScope"
            class="textarea-long"
            type="textarea"
            placeholder="请根据营业执照填写经营范围"
            maxlength="2000"
          />
        </el-form-item>

        <el-form-item label="单位类别：" prop="compClass">
          <el-select
            @visible-change="visibleChangeCompclass"
            v-model="ruleForm.cooperInfoBO.compClassName + ''"
            @change="changeCompClass"
            placeholder="请选择单位类别"
          >
            <!-- <el-option label="企业" value="compClassCompany"></el-option>
            <el-option label="个人" value="compClassPerson"></el-option>
            <el-option label="政府机构/事业单位/社会团体" value="compClassSocial"></el-option>-->
            <el-option
              v-for="item in COMPCLASSList"
              :label="item.dicValue"
              :value="item.dicKey"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="所在区域："
          prop="city2"
          :class="
            addressPlaceholder !== '请选择所在区域'
              ? 'checkClass'
              : 'checkClassRules'
          "
        >
          <div class="mustInfoS">*</div>
          <el-cascader
            class="addressDom"
            ref="addressSel"
            v-model="ruleForm.cooperInfoBO.city2"
            :props="propsAddress"
            :placeholder="addressPlaceholder"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="办公地址：">
          <el-input
            v-model="ruleForm.cooperInfoBO.officeAddress"
            class="input-short"
            placeholder="请输入办公地址"
            maxlength="200"
          />
        </el-form-item>

        <el-form-item label="币种：" prop="coin">
          <el-select
            @visible-change="visibleChangeMoney"
            v-model="ruleForm.cooperInfoBO.coinName + ''"
            @change="changeMoney"
            placeholder="请选择币种"
          >
            <el-option
              v-for="item in moneyList"
              :value="item.dicKey"
              :label="item.dicValue"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮编：" prop="post">
          <el-input
            maxlength="6"
            v-model="ruleForm.cooperInfoBO.post"
            class="input-short"
            placeholder="请输入邮编"
          />
        </el-form-item>

        <el-form-item label="上年营业额（万元）：" prop="lastYearTurnover">
          <el-input
            v-model="ruleForm.cooperInfoBO.lastYearTurnover"
            class="input-short"
            placeholder="请输入上年营业额（万元）"
            @input="checkLastYear"
            maxlength="15"
            @keydown.native="lastYearTurnoverChange"
          />
        </el-form-item>

        <el-form-item label="员工人数：">
          <el-input
            maxlength="9"
            v-model="ruleForm.cooperInfoBO.employeeNum"
            onkeyup="this.value=this.value=this.value.replace(/[^\d$]/g,'');"
            class="input-short"
            placeholder="请输入员工人数"
          />
        </el-form-item>
        <el-form-item label="是否外贸分包商：">
          <el-radio-group
            v-model="ruleForm.cooperInfoBO.isForeignTrade"
            @change="agreeChange"
            label="是否外贸分包商："
          >
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="所属集团公司名称：">
          <el-select v-model="ruleForm.cooperInfoBO.upSupplierId" placeholder="请选择所属集团公司名称 ">
            <el-option label="企业" value="upSupplierId1"></el-option>
            <el-option label="企业2" value="upSupplierId2"></el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item label="所属集团公司名称：">
          <el-input
            v-model="ruleForm.cooperInfoBO.upSupplierName"
            class="input-short"
            placeholder="请输入所属集团公司名称"
            @input="checkUpSupplierName"
            @blur="getQueryUnInfoByName"
            maxlength="200"
          />
        </el-form-item>

        <el-form-item label="公司网址：">
          <el-input
            v-model.trim="ruleForm.cooperInfoBO.website"
            class="input-short"
            placeholder="请输入公司网址"
            maxlength="100"
          />
        </el-form-item>

        <el-form-item label="公司简介：">
          <el-input
            v-model="ruleForm.cooperInfoBO.corpDesc"
            class="textarea-long"
            type="textarea"
            placeholder="请输入公司简介"
            maxlength="1000"
          />
        </el-form-item>

        <el-form-item label="组织架构及营销网络：">
          <el-input
            v-model="ruleForm.cooperInfoBO.orgDesc"
            class="textarea-long"
            type="textarea"
            placeholder="请输入组织架构及营销网络"
            maxlength="1000"
          />
        </el-form-item>
      </el-form>
      <el-form
        ref="ruleForm1"
        :model="ruleForm.legalContactBO"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title :title="title1" />

        <el-form-item label="姓名：" prop="contactName">
          <el-input
            v-model.trim="ruleForm.legalContactBO.contactName"
            class="input-long"
            placeholder="请输入法定代表人姓名"
            maxlength="50"
          />
        </el-form-item>

        <el-form-item label="证件类型：" prop="idType">
          <el-select
            value="ruleForm.legalContactBO.idTypeName"
            @visible-change="visibleChangeIDTYPE"
            v-model="ruleForm.legalContactBO.idTypeName + ''"
            @change="changeIdType"
            placeholder="请选择证件类型"
          >
            <!-- <el-option label="身份证" value="idCard"></el-option>
            <el-option label="护照" value="passport"></el-option>-->
            <el-option
              v-for="item in IDList"
              :label="item.dicValue"
              :value="item.dicKey"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="证件号码：" prop="idNumber">
          <el-input
            v-model="ruleForm.legalContactBO.idNumber"
            class="input-short"
            placeholder="请输入证件号码"
            @input="replaceUpper"
            ref="idNumber"
            :maxlength="idLength"
          />
        </el-form-item>

        <el-form-item label="手机号码：" prop="contactMobile">
          <el-input
            maxlength="11"
            v-model.number="ruleForm.legalContactBO.contactMobile"
            class="input-short"
            placeholder="请输入手机号码"
          />
        </el-form-item>

        <el-form-item label="固定电话：">
          <el-input
            maxlength="30"
            v-model="ruleForm.legalContactBO.contactTel"
            onkeyup="this.value=this.value.replace(/[^\d\(\)\（\）\-\+]/g,'');"
            class="input-short"
            placeholder="请输入固定电话"
          />
        </el-form-item>
      </el-form>
      <el-form
        ref="ruleForm2"
        :model="ruleForm.supplierFinanceBO"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title :title="title2" />

        <el-form-item label="开户银行：" prop="bankName">
          <el-input
            v-model="ruleForm.supplierFinanceBO.bankName"
            class="input-long"
            placeholder="请输入开户银行"
            maxlength="200"
          />
        </el-form-item>

        <el-form-item label="银行账号：" prop="bankId">
          <el-input
            maxlength="25"
            v-model="ruleForm.supplierFinanceBO.bankId"
            placeholder="请输入银行账号"
          />
        </el-form-item>

        <el-form-item label="开票地址：" prop="billingAddress">
          <el-input
            v-model="ruleForm.supplierFinanceBO.billingAddress"
            class="input-short"
            placeholder="请输入开票地址"
            maxlength="200"
          />
        </el-form-item>

        <el-form-item label="开票电话：" prop="billingTelephone">
          <el-input
            v-model="ruleForm.supplierFinanceBO.billingTelephone"
            class="input-short"
            placeholder="请输入开票电话"
            maxlength="30"
          />
        </el-form-item>
      </el-form>

      <el-form
        ref="ruleForm3"
        :model="ruleForm"
        :rules="rules"
        label-width="135px"
        class="demo-ruleForm"
      >
        <div class="uploadInfo">
          <el-card-title :title="title3" />
          <p class="commonTxtTip">
            支持格式：.jpg .png .jpeg .gif 每个不超过5M，.xls .xlsx .doc .docx
            .pdf每个不超过15M
          </p>
          <div class="safe">
            <span class="text">营业执照副本</span>
            <!-- <el-form-item label="发证机关及网址：" prop="name">
              <el-input
                v-model="ruleForm.supplierFileBOS[0].website"
                class="input-short"
                placeholder="请输入发证机关的网址"
              />
            </el-form-item>-->
            <div class="block">
              <el-form-item class="validityStart" label="有效期：">
                <div class="mustInfoY">*</div>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="ruleForm.supplierFileBOS[0].validityStart"
                  type="date"
                  :picker-options="{
                    disabledDate: (time) => {
                      if (this.ruleForm.supplierFileBOS[0].validityEnd) {
                        return (
                          time.getTime() >
                          new Date(
                            this.ruleForm.supplierFileBOS[0].validityEnd
                          ).getTime() -
                            86400000
                        );
                      }
                      return time.getTime() > Date.now();
                    },
                  }"
                  placeholder="开始时间"
                ></el-date-picker
                >&nbsp;-&nbsp;
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="ruleForm.supplierFileBOS[0].validityEnd"
                  :disabled="ruleForm.supplierFileBOS[0].isLongValidity"
                  type="date"
                  :picker-options="{
                    disabledDate: (time) => {
                      if (this.ruleForm.supplierFileBOS[0].validityStart) {
                        return (
                          time.getTime() <
                          new Date(
                            this.ruleForm.supplierFileBOS[0].validityStart
                          ).getTime()
                        );
                      }
                    },
                  }"
                  placeholder="结束时间"
                ></el-date-picker>
                <el-checkbox
                  v-model="ruleForm.supplierFileBOS[0].isLongValidity"
                  class="checkBox"
                  >长期</el-checkbox
                >
              </el-form-item>
            </div>
            <el-form-item class="scanFile" label="资质上传：" prop="scanFile">
              <div style="height: 86px">
                <el-file-upload
                  ref="upload"
                  :on-change="changeFile"
                  :on-success="handleSuccess"
                  :on-error="fileError"
                  :on-delete="onFileDelete"
                  :data="upLoadData"
                  :file-list="fileList"
                  :auto-upload="true"
                  :limit="1"
                  :action="importFileUrl"
                  file-ref="fileRef2"
                  :picturePath="picturePath"
                  :handlePictureCardPreview="handlePictureCardPreview"
                  :before-upload="beforeAvatarUpload"
                  style="height: 86px"
                ></el-file-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="safe">
          <span class="text">法定代表人授权委托书</span>
          <div class="block">
            <el-form-item class="scanFile2" label="资质上传：" prop="scanFile2">
              <div style="height: 86px">
                <el-file-upload
                  ref="upload"
                  :on-change="changeFile1"
                  :on-success="handleSuccess1"
                  :on-error="fileError1"
                  :on-delete="onFileDelete1"
                  :file-list="fileList1"
                  :auto-upload="true"
                  :limit="1"
                  :action="importFileUrl"
                  file-ref="fileRef2"
                  :handlePictureCardPreview="handlePictureCardPreview"
                  style="height: 86px"
                  :before-upload="beforeAvatarUpload"
                ></el-file-upload>
              </div>
              <p class="commonTxt">
                请先下载
                <a
                  :href="downFileUrl"
                  download="授权委托书模板.doc"
                  target="_blank"
                  >授权委托书模板</a
                >
                ，按要求填写后将文件扫描上传
              </p>
            </el-form-item>
          </div>

          <div class="safe">
            <span class="text">法定代表人身份证</span>
            <el-form-item class="scanFile" label="资质上传：" prop="scanFile">
              <div style="height: 86px">
                <el-file-upload
                  ref="upload"
                  :on-change="changeFile2"
                  :on-success="handleSuccess2"
                  :on-error="fileError2"
                  :on-delete="onFileDelete2"
                  :file-list="fileList2"
                  :auto-upload="true"
                  :limit="1"
                  :action="importFileUrl"
                  file-ref="fileRef2"
                  :handlePictureCardPreview="handlePictureCardPreview2"
                  :before-upload="beforeAvatarUpload"
                  style="height: 86px"
                ></el-file-upload>
              </div>
            </el-form-item>
          </div>
          <div class="safe">
            <span class="text">纳税人证明材料</span>
            <el-form-item class="scanFile" label="资质上传：" prop="scanFile">
              <div style="height: 86px">
                <el-file-upload
                  ref="upload"
                  :on-change="changeFile3"
                  :on-success="handleSuccess3"
                  :on-error="fileError3"
                  :on-delete="onFileDelete3"
                  :file-list="fileList3"
                  :auto-upload="true"
                  :limit="1"
                  :action="importFileUrl"
                  file-ref="fileRef2"
                  :handlePictureCardPreview="handlePictureCardPreview3"
                  :before-upload="beforeAvatarUpload"
                  style="height: 86px"
                ></el-file-upload>
              </div>
            </el-form-item>
          </div>
          <div class="safe">
            <span class="text">税务登记证</span>
            <el-form-item class="scanFile" label="资质上传：" prop="scanFile">
              <div style="height: 86px">
                <el-file-upload
                  ref="upload"
                  :on-change="changeFile4"
                  :on-success="handleSuccess4"
                  :on-error="fileError4"
                  :on-delete="onFileDelete4"
                  :file-list="fileList4"
                  :auto-upload="true"
                  :limit="1"
                  :action="importFileUrl"
                  file-ref="fileRef2"
                  :handlePictureCardPreview="handlePictureCardPreview4"
                  :before-upload="beforeAvatarUpload"
                  style="height: 86px"
                ></el-file-upload>
              </div>
            </el-form-item>
          </div>
          <div class="safe">
            <span class="text">组织机构代码证</span>
            <div class="block">
              <el-form-item class="validityStart" label="有效期：">
                <div class="mustInfoY">*</div>
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="ruleForm.supplierFileBOS[5].validityStart"
                  type="date"
                  :picker-options="{
                    disabledDate: (time) => {
                      if (this.ruleForm.supplierFileBOS[5].validityEnd) {
                        return (
                          time.getTime() >
                          new Date(
                            this.ruleForm.supplierFileBOS[5].validityEnd
                          ).getTime() -
                            86400000
                        );
                      }
                      return time.getTime() > Date.now();
                    },
                  }"
                  placeholder="开始时间"
                ></el-date-picker
                >&nbsp;-&nbsp;
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="ruleForm.supplierFileBOS[5].validityEnd"
                  :disabled="ruleForm.supplierFileBOS[5].isLongValidity"
                  type="date"
                  :picker-options="{
                    disabledDate: (time) => {
                      if (this.ruleForm.supplierFileBOS[5].validityStart) {
                        return (
                          time.getTime() <
                          new Date(
                            this.ruleForm.supplierFileBOS[5].validityStart
                          ).getTime()
                        );
                      }
                    },
                  }"
                  placeholder="结束时间"
                ></el-date-picker>
                <el-checkbox
                  v-model="ruleForm.supplierFileBOS[5].isLongValidity"
                  class="checkBox"
                  >长期</el-checkbox
                >
              </el-form-item>
            </div>
            <el-form-item class="scanFile" label="资质上传：" prop="scanFile">
              <div style="height: 86px">
                <el-file-upload
                  ref="upload"
                  :on-change="changeFile6"
                  :on-success="handleSuccess6"
                  :on-error="fileError6"
                  :on-delete="onFileDelete6"
                  :data="upLoadData"
                  :file-list="fileList6"
                  :auto-upload="true"
                  :limit="1"
                  :action="importFileUrl"
                  file-ref="fileRef2"
                  :picturePath="picturePath"
                  :handlePictureCardPreview="handlePictureCardPreview6"
                  :before-upload="beforeAvatarUpload"
                  style="height: 86px"
                ></el-file-upload>
              </div>
            </el-form-item>
          </div>
          <!-- <div class="safe companyInfo" v-for="(item, key) in cloneObj" :key="key">
            <children ref="children" />
          </div>

          <div class="addBox" @click="addTravel">
            <img src="../../../../assets/images/addBox.png" alt />
            添加资质
          </div>-->
        </div>
      </el-form>
      <div class="footer">
        <!-- <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="Previous('ruleForm')"
      >
        <span>上一步</span>
      </el-button>-->
        <el-button
          class="right-btn btn"
          size="mini"
          type="primary-icon-medium"
          @click="submitForm('ruleForm')"
          :disabled="perfectDisabled"
        >
          <span>下一步</span>
        </el-button>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="showInfoModal"
      width="380px"
      class="dialog-center"
      show-divider
      show-shadow
      :before-close="handleClose"
      custom-class="el-dialog--customize"
    >
      <span
        >供应商信息已存在，可对信息进行修改，合作申请审批通过后供应商信息将会更新，为平台共享信息。</span
      >
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="showInfoModal = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="perfectInfoShow"
      width="380px"
      class="dialog-center"
      show-divider
      show-shadow
      :before-close="handleClose"
      custom-class="el-dialog--customize"
    >
      <span>申请合作需在注册开始时间8小时内完善后提交，否则注册信息删除</span>
      <span slot="footer">
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="perfectInfoShow = false"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
window.onbeforeunload = function (e) {
  e = e || window.event;

  // 兼容IE8和Firefox 4之前的版本
  if (e) {
    e.returnValue = "关闭提示";
  }

  // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
  return "关闭提示";
};

import {
  getSaveSupplierInfo,
  getPmcAdress,
  uploads,
  getCompany,
  getQueryUnInfoByName,
  getQryDictByCode,
  getQueryInfoByCode,
  queryInfoBySupName,
} from "@/api/register";
import children from "./children";
let id = 0;
export default {
  props: ["companyMessage"],
  components: {
    children,
  },
  data() {
    return {
      fileList1: [],
      isSid: false,
      sID: "",
      downFileUrl: this.$addUrlPerFix(process.env.VUE_APP_FILE_URL),
      perfectDisabled: false,
      perfectInfoShow: false,
      showInfoModal: false,
      addressPlaceholder: "请选择所在区域",
      regCapital: 15,
      factCapital: 15,
      lastYearTurnoverLength: 15,
      idLength: null,
      messageHeight: null,
      addType: true,
      addressType: false,
      taxFile: true,
      regNumBlurInfo: "",
      taxCodeBlurInfo: "",
      orgCodeBlurInfo: "",
      supplierCode: "",
      percentage: "100",
      codeList: [],
      moneyList: [],
      COMPCLASSList: [],
      IDList: [],
      taxerList: [],
      // 批文附件上传
      picturePath: "../../.././examples/assets/images/file-icon/",
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/reg/users/signup/uploadFileToOss", // 上传地址
      upLoadData: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList: [],
      fileListData: [],
      percentage1: "100",
      codeList1: [],
      moneyList1: [],
      COMPCLASSList1: [],
      IDList1: [],
      // 批文附件上传
      picturePath1: "../../.././examples/assets/images/file-icon/",
      upLoadData1: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileListData1: [],
      //批文附件上传2
      upLoadData1: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList2: [],
      fileListData2: [],
      percentage2: "100",
      //批文附件上传3
      upLoadData1: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList3: [],
      fileListData3: [],
      percentage3: "100",
      //批文附件上传4
      upLoadData1: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList4: [],
      fileListData4: [],
      percentage4: "100",
      //批文附件上传5
      upLoadData1: {
        cgformName: "t_b_tender_project",
        cgformField: "projectAttachment",
        cgformId: "",
      },
      fileList6: [],
      fileListData6: [],
      percentage6: "100",
      supplier: {
        supplierName: "",
      },
      cooperInfo: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      isLongValidity: false,
      foundTime: "",
      corpDesc: "",
      addressArr: [],
      propsAddress: {
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level == 0) {
            getPmcAdress({ addressCode: "000000" }).then((res) => {
              // console.log(res, "地区打印详情");
              const nodes = res.data.data.map((item) => ({
                value: item,
                label: item.addressName,
                leaf: item.lastFlag != 0,
              }));
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
              // console.log(nodes, "地区数据子节点");
            });
          } else {
            getPmcAdress({ addressCode: node.value.addressCode }).then(
              (res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item,
                  label: item.addressName,
                  leaf: item.lastFlag != 0,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }
            );
          }
        },
      },
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      cloneObj: [],
      imageUrl1: "", //上传图片
      title: "基本信息",
      title1: "法定代表人",
      title2: "财务信息",
      title3: "上传资质",
      imageUrl: "",
      checked: false,
      ruleForm: {
        contactId: null,
        supplierCode: "",
        supplierFileBOS: [
          {
            // uploadId: "",
            // fileName: "",
            // fileType: "",
            // fileAddress: "",
            // fileSize: "",
            // website: "",
            validityStart: null,
            validityEnd: null,
            isLongValidity: null,
          },
          {
            // uploadId: "",
            // fileName: "",
            // fileType: "",
            // fileAddress: "",
            // fileSize: ""
          },
          {
            // uploadId: "",
            // fileName: "",
            // fileType: "",
            // fileAddress: "",
            // fileSize: ""
          },
          {
            // uploadId: "",
            // fileName: "",
            // fileType: "",
            // fileAddress: "",
            // fileSize: ""
          },
          {
            // uploadId: "",
            // fileName: "",
            // fileType: "",
            // fileAddress: "",
            // fileSize: ""
          },
          {
            // uploadId: "",
            // fileName: "",
            // fileType: "",
            // fileAddress: "",
            // fileSize: "",
            validityStart: null,
            validityEnd: null,
            isLongValidity: null,
          },
        ],
        cooperInfoBO: {
          isonshore: 1,
          supplierCode: "",
          supplierChineseName: "",
          supplierEnglishName: "",
          supplierShortname: "",
          unifiedCode: "",
          regNum: "",
          city2: [],
          orgCode: "",
          taxCode: "",
          corpDesc: "",
          officeAddress: "",
          coin: "",
          coinName: "",
          regCapl: "",
          factCapl: "",
          taxpayerId: "",
          taxpayerName: "",
          address: "",
          supplierScope: "",
          compClass: "",
          compClassName: "",
          location: "",
          locationName: "",
          province: "",
          provinceName: "",
          city: "",
          cityName: "",
          county: "",
          countyName: "",
          lastYearTurnover: "",
          employeeNum: "",
          isForeignTrade: "0",
          orgDesc: "",
          website: "",
          compType: "",
          compTypeName: "",
          upSupplierId: null,
          upSupplierName: "",
          foundTime: "",
          regSource: "2",
        },
        supplierFinanceBO: {
          bankId: "",
          bankName: "",
          billingAddress: "",
          billingTelephone: "",
        },
        legalContactBO: {
          contactName: "",
          contactMobile: "",
          contactTel: "",
          idType: "",
          idNumber: "",
          idTypeName: "",
        },
      },
      fileList: [],
      rules: {
        supplierChineseName: [
          {
            required: true,
            message: "请输入正确的单位名称（中文）",
            trigger: ["blur", "change"],
            pattern: /^[\u4e00-\u9fa5\(\)\（\）]+$/,
          },
        ],
        supplierEnglishName: [
          {
            required: true,
            message: "请输入单位名称(英文)",
            trigger: ["blur"],
          },
        ],
        supplierShortname: [
          {
            required: true,
            message: "请输入单位简称",
            trigger: ["blur"],
          },
        ],
        website: [
          {
            required: true,
            pattern: /^[0-9A-Za-z\.]+$/,
            message: "请输入正确的公司网址",
            trigger: ["blur"],
          },
        ],
        unifiedCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          },
        ],
        regNum: [
          // {
          //   required: true,
          //   message: "请输入工商注册号",
          //   trigger: "blur"
          // },
          // {
          //   min: 15,
          //   message: "长度在15个字符",
          //   trigger: ["blur"]
          // },
          // {
          //   required: true,
          //   pattern: /\d+$/,
          //   message: "请输入正确的工商注册号",
          //   trigger: ["blur"]
          // }
        ],
        orgCode: [
          // {
          //   required: true,
          //   message: "请输入组织机构代码",
          //   trigger: "blur"
          // },
          // {
          //   min: 9,
          //   message: "长度在9个字符",
          //   trigger: ["blur"]
          // },
          // {
          //   required: true,
          //   pattern: /[0-9A-HJ-NPQRTUWXY]$/,
          //   message: "请输入正确的组织机构代码(大写英文不含I/O/Z/S/V)",
          //   trigger: ["blur"]
          // }
        ],
        taxCode: [
          // {
          //   required: true,
          //   message: "请输入纳税人识别号",
          //   trigger: "blur"
          // },
          // {
          //   min: 20,
          //   message: "长度在20个字符",
          //   trigger: ["blur"]
          // },
          // {
          //   required: true,
          //   pattern: /[0-9A-HJ-NPQRTUWXY]$/,
          //   message: "请输入正确的组织机构代码(大写英文不含I/O/Z/S/V)",
          //   trigger: ["blur"]
          // }
        ],
        compType: [
          {
            required: true,
            message: "请选择公司类型",
            trigger: ["blur", "change"],
          },
        ],
        foundTime: [
          {
            required: true,
            message: "请选择成立日期",
            trigger: ["blur"],
          },
        ],
        validityStart: [
          {
            required: true,
            message: "请选择有效期",
            trigger: ["blur"],
          },
        ],
        regCapl: [
          { required: true, message: "请输入注册资本", trigger: "blur" },
          {
            pattern: /(^[1-9]\d{0,15}\.?\d{0,4}$)|(^0\.\d{0,4}$)/,
            message: "请正确输入注册资本(小数点0-4位)",
            trigger: "blur",
          },
        ],
        factCapl: [
          {
            pattern: /(^[1-9]\d{0,15}\.?\d{0,4}$)|(^0\.\d{0,4}$)/,
            message: "请正确输入实收资本(小数点0-4位)",
            trigger: "blur",
          },
        ],
        taxpayerId: [
          {
            required: true,
            message: "请选择纳税人类型",
            trigger: ["blur", "change"],
          },
        ],
        address: [{ required: true, message: "请输入住所", trigger: ["blur"] }],
        supplierScope: [
          {
            required: true,
            message: "请根据营业执照填写经营范围",
            trigger: ["blur"],
          },
        ],
        compClass: [
          {
            required: true,
            message: "请选择单位类别",
            trigger: ["blur", "change"],
          },
        ],
        // 地区接口调试好打开
        city2: [
          {
            required: true,
            message: "请选择所在区域",
            // trigger: ["blur"]
            trigger: "change",
          },
        ],
        coin: [
          {
            required: true,
            message: "请选择币种",
            trigger: ["blur", "change"],
          },
        ],
        post: [
          {
            required: true,
            message: "请输入邮编",
            trigger: ["blur"],
          },
          {
            min: 6,
            message: "请输入正确的邮编",
            pattern: /^\d{6}$/,
            trigger: ["blur"],
          },
        ],
        contactName: [
          {
            required: true,
            message: "请输入法定代表人姓名",
            trigger: ["blur"],
          },
          // {
          //   min: 1,
          //   max: 50,
          //   message: "长度在 1 到 50 个汉字",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            // pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
            pattern: /^[^&]+$/,
            message: "不可输入&",
            trigger: ["blur"],
          },
        ],
        idType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: ["blur", "change"],
          },
        ],
        idNumber: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: ["blur"],
          },
          // {
          //   min: 15,
          //   max: 18,
          //   message: "请输入正确的身份证号码",
          //   trigger: "blur"
          // },
          {
            required: true,
            pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码",
            trigger: ["blur"],
          },
        ],
        contactMobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur"],
          },
          {
            required: true,
            pattern: /(^1[3456789]\d{9}$)/,
            message: "请输入正确的手机号码",
            trigger: ["blur"],
          },
        ],
        billingAddress: [
          {
            required: true,
            message: "请输入开票地址",
            // trigger: ["blur"]
            trigger: "blur",
          },
        ],
        billingTelephone: [
          { required: true, message: "请输入开票电话", trigger: "blur" },
          // {
          //   min: 7,
          //   message: "请输入正确的开票电话",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^([\d\-\+\(\)\（\）]+)+$/,
            message: "请输入正确的开票电话",
            // trigger: ["blur"]
            trigger: "blur",
          },
        ],
        bankName: [
          {
            required: true,
            message: "请输入开户银行",
            trigger: ["blur"],
          },
        ],
        bankId: [
          {
            required: true,
            message: "请输入银行账号",
            // trigger: ["blur"]
            trigger: "blur",
          },
          {
            required: true,
            pattern: /(^\d+$)/,
            message: "请输入正确的银行账号",
            // trigger: ["blur"]
            trigger: "blur",
          },
        ],
        scanFile: [
          {
            required: true,
            message: "请上传安全生产许可证扫描件",
            trigger: "change",
          },
        ],
        scanFile2: [
          {
            required: true,
            message: "请上传合格业绩证明资质",
            trigger: "change",
          },
        ],
        scanFile3: [
          {
            required: true,
            message: "请上传公司资质",
            trigger: "change",
          },
        ],
      },
      uploadIdx: 0,
    };
  },
  mounted() {
    // this.fileList2 = [];
    console.log(this.ruleForm);
    this.getBrowserHeight();
    //  if (!this.$refs.addressSel) return false;
    //查询上一步的公司名
    this.$eventBus.$on("supplierName", (res) => {
      this.ruleForm.cooperInfoBO.supplierChineseName = res.supplierName;
      // console.log(res);
    });
    //查询直接申请合作的完善信息
    this.$eventBus.$on("toPerfectInfoByName", (res) => {
      console.log(res, "查看结果");
      if (res) {
        this.ruleForm.cooperInfoBO.supplierChineseName = res.supplierName;
        if (this.ruleForm.cooperInfoBO.supplierChineseName) {
          queryInfoBySupName({
            mobile: res.mobile,
            supplierName: this.ruleForm.cooperInfoBO.supplierChineseName,
            // supplierName: "北京学而思教育科技有限公司",
            isShowLoading: true,
          }).then((result) => {
            if (result) {
              if (result.data.data.cooperInfoBO.sID) {
                this.isSid = true;
              }
              this.sID = result.data.data.cooperInfoBO.sID;
              if (result.data.data.supplierFinanceBO.bankId != "") {
                this.showInfoModal = true;
              } else {
                this.perfectInfoShow = true;
              }
              if (!this.$refs.addressSel) return false;
              if (result.data.data.cooperInfoBO.city != "") {
                this.addType = false;
              }
              if (result.data.data.cooperInfoBO.countyName != "") {
                this.$refs.addressSel.inputValue =
                  result.data.data.cooperInfoBO.locationName +
                  "/" +
                  result.data.data.cooperInfoBO.cityName +
                  "/" +
                  result.data.data.cooperInfoBO.countyName;
              } else {
                this.$refs.addressSel.inputValue =
                  result.data.data.cooperInfoBO.locationName;
              }
              this.ruleForm.cooperInfoBO.city2 = [
                { addressCode: result.data.data.cooperInfoBO.location },
                { addressCode: result.data.data.cooperInfoBO.province },
                { addressCode: result.data.data.cooperInfoBO.city },
                { addressCode: result.data.data.cooperInfoBO.county },
              ];
              console.log(this.ruleForm.cooperInfoBO.city2);
              if (result.data.data.cooperInfoBO.province != "") {
                this.rules.city2 = [];
              }
              // result.data.data.cooperInfoBO.regCapl = Number(
              //   result.data.data.cooperInfoBO.regCapl
              // );
              this.ruleForm.cooperInfoBO.locationName =
                result.data.data.cooperInfoBO.locationName;
              this.ruleForm.cooperInfoBO.provinceName =
                result.data.data.cooperInfoBO.provinceName;
              this.ruleForm.cooperInfoBO.cityName =
                result.data.data.cooperInfoBO.cityName;
              this.ruleForm.cooperInfoBO.countyName =
                result.data.data.cooperInfoBO.countyName;
              this.ruleForm.cooperInfoBO.location =
                result.data.data.cooperInfoBO.location;
              this.ruleForm.cooperInfoBO.province =
                result.data.data.cooperInfoBO.province;
              this.ruleForm.cooperInfoBO.city =
                result.data.data.cooperInfoBO.city;
              this.ruleForm.cooperInfoBO.county =
                result.data.data.cooperInfoBO.county;
              result.data.data.cooperInfoBO.isFeignTrade =
                result.data.data.cooperInfoBO.isFeignTrade + "";

              this.ruleForm.contactId =
                result.data.data.legalContactBO.contactId;
              // this.ruleForm.legalContactBO = result.data.data.legalContactBO;
              this.ruleForm.legalContactBO.contactName =
                result.data.data.legalContactBO.contactName;
              this.ruleForm.legalContactBO.contactMobile =
                result.data.data.legalContactBO.contactMobile;
              // this.ruleForm.legalContactBO.idType = result.data.data.legalContactBO.idType;
              this.ruleForm.cooperInfoBO = result.data.data.cooperInfoBO;
              this.ruleForm.cooperInfoBO.isForeignTrade =
                this.ruleForm.cooperInfoBO.isForeignTrade + "";
              if (result.data.data.cooperInfoBO.foundTime) {
                this.$set(
                  this.ruleForm.cooperInfoBO,
                  "foundTime",
                  result.data.data.cooperInfoBO.foundTime.slice(0, 10)
                );
              }
              this.ruleForm.supplierFinanceBO =
                result.data.data.supplierFinanceBO;
              result.data.data.supplierFileBOS.forEach((item) => {
                // item.isLongValidity = item.isLongValidity === 0 ? false : true;
                if (item.isLongValidity === 0) {
                  item.isLongValidity = false;
                } else {
                  item.isLongValidity = true;
                }
                if (item.fJName) {
                  if (item.fJName.indexOf("xls") !== -1) {
                    item.fileAddress =
                      "data:image/png;base64,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";
                  } else if (item.fJName.indexOf("doc") !== -1) {
                    item.fileAddress =
                      "data:image/png;base64,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";
                  } else if (item.fJName.indexOf("pdf") !== -1) {
                    item.fileAddress =
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
                  }
                }
              });

              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 1
                ) >= 0
              ) {
                if (
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 1
                    )
                  ].downLoadUrl
                ) {
                  this.fileList = [
                    {
                      name:
                        result.data.data.supplierFileBOS[
                          result.data.data.supplierFileBOS.findIndex(
                            (item) => item.fileType === 1
                          )
                        ].fileName,
                      url:
                        result.data.data.supplierFileBOS[
                          result.data.data.supplierFileBOS.findIndex(
                            (item) => item.fileType === 1
                          )
                        ].fileAddress,
                      percentage: 100,
                      response: {
                        data: [
                          {
                            filePreview:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 1
                                )
                              ].fileClass,
                            fileName:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 1
                                )
                              ].fileClass,
                            downloadUrl:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 1
                                )
                              ].fileAddress,
                            fileType:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 1
                                )
                              ].fileType,
                            uploadId:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 1
                                )
                              ].uploadId,
                          },
                        ],
                      },
                    },
                  ];
                }
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 2
                ) >= 0
              ) {
                if (
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 2
                    )
                  ].downLoadUrl
                ) {
                  this.fileList1 = [
                    {
                      url:
                        result.data.data.supplierFileBOS[
                          result.data.data.supplierFileBOS.findIndex(
                            (item) => item.fileType === 2
                          )
                        ].fileAddress,
                      percentage: 100,
                      response: {
                        data: [
                          {
                            filePreview:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 2
                                )
                              ].fileClass,
                            fileName:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 2
                                )
                              ].fileClass,
                            downloadUrl:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 2
                                )
                              ].fileAddress,
                            fileType:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 2
                                )
                              ].fileType,
                            uploadId:
                              result.data.data.supplierFileBOS[
                                result.data.data.supplierFileBOS.findIndex(
                                  (item) => item.fileType === 2
                                )
                              ].uploadId,
                          },
                        ],
                      },
                    },
                  ];
                }
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 3
                ) >= 0
              ) {
                this.fileList2 = [
                  {
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 3
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }

              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 4
                ) >= 0
              ) {
                this.fileList3 = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 4
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 4
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 5
                ) >= 0
              ) {
                this.fileList4 = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 5
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 5
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 7
                ) >= 0
              ) {
                this.fileList6 = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 7
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 7
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }

              result.data.data.supplierFileBOS.forEach((item) => {
                if (item.fileType === 1) {
                  this.ruleForm.supplierFileBOS[0].fileAddress =
                    item.fileAddress;
                  this.ruleForm.supplierFileBOS[0].fileName = "营业执照副本";
                  this.ruleForm.supplierFileBOS[0].fileSize = item.fileSize;
                  this.ruleForm.supplierFileBOS[0].fileType = item.fileType;
                  this.ruleForm.supplierFileBOS[0].uploadId = item.uploadId;
                }
                if (item.fileType === 2) {
                  this.ruleForm.supplierFileBOS[1].fileAddress =
                    item.fileAddress;
                  this.ruleForm.supplierFileBOS[1].fileName =
                    "法定代表人授权委托书";
                  this.ruleForm.supplierFileBOS[1].fileSize = item.fileSize;
                  this.ruleForm.supplierFileBOS[1].fileType = item.fileType;
                  this.ruleForm.supplierFileBOS[1].uploadId = item.uploadId;
                }
              });
              for (
                let fileIdxe = 2;
                fileIdxe <= result.data.data.supplierFileBOS.length - 1;
                fileIdxe++
              ) {
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileAddress =
                  result.data.data.supplierFileBOS[fileIdxe].fileAddress;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileName =
                  result.data.data.supplierFileBOS[fileIdxe].fileName;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileSize =
                  result.data.data.supplierFileBOS[fileIdxe].fileSize;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileType =
                  result.data.data.supplierFileBOS[fileIdxe].fileType;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].uploadId =
                  result.data.data.supplierFileBOS[fileIdxe].uploadId;
              }
              if (
                result.data.data.supplierFileBOS[
                  result.data.data.supplierFileBOS.findIndex(
                    (item) => item.fileType === 1
                  )
                ]
              ) {
                this.ruleForm.supplierFileBOS[0].validityStart =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 1
                    )
                  ].validityStart;
                this.ruleForm.supplierFileBOS[0].validityEnd =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 1
                    )
                  ].validityEnd;
                this.ruleForm.supplierFileBOS[0].isLongValidity =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 1
                    )
                  ].isLongValidity;
              }
              if (
                result.data.data.supplierFileBOS[
                  result.data.data.supplierFileBOS.findIndex(
                    (item) => item.fileType === 7
                  )
                ]
              ) {
                this.ruleForm.supplierFileBOS[5].validityStart =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 7
                    )
                  ].validityStart;
                this.ruleForm.supplierFileBOS[5].validityEnd =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 7
                    )
                  ].validityEnd;
                this.ruleForm.supplierFileBOS[5].isLongValidity =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 7
                    )
                  ].isLongValidity;
              }
              if (result.data.data.cooperInfoBO.unifiedCode) {
                this.taxFile = false;
                this.rules.regNum = [];
                this.rules.orgCode = [];
                this.rules.taxCode = [];
              } else {
                this.taxFile = true;
                this.rules.unifiedCode = [];
                this.$refs.unifiedCode.clearValidate();
                if (result.data.data.supplierFileBOS[4]) {
                  this.ruleForm.supplierFileBOS[5].fileAddress =
                    result.data.data.supplierFileBOS[4].fileAddress;
                  this.ruleForm.supplierFileBOS[5].fileName =
                    result.data.data.supplierFileBOS[4].fileName;
                  this.ruleForm.supplierFileBOS[5].fileSize =
                    result.data.data.supplierFileBOS[4].fileSize;
                  this.ruleForm.supplierFileBOS[5].fileType =
                    result.data.data.supplierFileBOS[4].fileType;
                  this.ruleForm.supplierFileBOS[5].uploadId =
                    result.data.data.supplierFileBOS[4].uploadId;
                }
              }
            }
          });
        }
      }
      console.log(this.ruleForm.supplierFileBOS, "--附件");
    });
    //查询提交过的完善信息
    this.$eventBus.$on("querySupplierCode", (res) => {
      if (res) {
        this.ruleForm.cooperInfoBO.supplierCode = res;
        this.$eventBus.$emit(
          "childrenCode",
          this.ruleForm.cooperInfoBO.supplierCode
        );
        if (this.ruleForm.cooperInfoBO.supplierCode) {
          getQueryInfoByCode({
            supplierCode: this.ruleForm.cooperInfoBO.supplierCode,
            isShowLoading: true,
          }).then((result) => {
            if (result) {
              if (result.data.data.cooperInfoBO.sID) {
                this.isSid = true;
              }
              this.sID = result.data.data.cooperInfoBO.sID;
              if (!this.$refs.addressSel) return false;
              if (result.data.data.cooperInfoBO.city != "") {
                this.addType = false;
              }
              if (result.data.data.cooperInfoBO.countyName != "") {
                this.$refs.addressSel.inputValue =
                  result.data.data.cooperInfoBO.locationName +
                  "/" +
                  result.data.data.cooperInfoBO.cityName +
                  "/" +
                  result.data.data.cooperInfoBO.countyName;
              } else {
                this.$refs.addressSel.inputValue =
                  result.data.data.cooperInfoBO.locationName;
              }
              this.ruleForm.cooperInfoBO.city2 = [
                { addressCode: result.data.data.cooperInfoBO.location },
                { addressCode: result.data.data.cooperInfoBO.province },
                { addressCode: result.data.data.cooperInfoBO.city },
                { addressCode: result.data.data.cooperInfoBO.county },
              ];
              console.log(this.ruleForm.cooperInfoBO.city2);
              if (result.data.data.cooperInfoBO.province != "") {
                this.rules.city2 = [];
              }
              result.data.data.cooperInfoBO.regCapl = Number(
                result.data.data.cooperInfoBO.regCapl
              );
              this.ruleForm.cooperInfoBO.locationName =
                result.data.data.cooperInfoBO.locationName;
              this.ruleForm.cooperInfoBO.provinceName =
                result.data.data.cooperInfoBO.provinceName;
              this.ruleForm.cooperInfoBO.cityName =
                result.data.data.cooperInfoBO.cityName;
              this.ruleForm.cooperInfoBO.countyName =
                result.data.data.cooperInfoBO.countyName;
              this.ruleForm.cooperInfoBO.location =
                result.data.data.cooperInfoBO.location;
              this.ruleForm.cooperInfoBO.province =
                result.data.data.cooperInfoBO.province;
              this.ruleForm.cooperInfoBO.city =
                result.data.data.cooperInfoBO.city;
              this.ruleForm.cooperInfoBO.county =
                result.data.data.cooperInfoBO.county;
              result.data.data.cooperInfoBO.isFeignTrade =
                result.data.data.cooperInfoBO.isFeignTrade + "";

              this.ruleForm.contactId =
                result.data.data.legalContactBO.contactId;
              // this.ruleForm.legalContactBO = result.data.data.legalContactBO;
              this.ruleForm.legalContactBO.contactName =
                result.data.data.legalContactBO.contactName;
              this.ruleForm.legalContactBO.contactMobile =
                result.data.data.legalContactBO.contactMobile;
              // this.ruleForm.legalContactBO.idType = result.data.data.legalContactBO.idType;
              this.ruleForm.cooperInfoBO = result.data.data.cooperInfoBO;
              this.ruleForm.cooperInfoBO.isForeignTrade =
                this.ruleForm.cooperInfoBO.isForeignTrade + "";
              if (result.data.data.cooperInfoBO.foundTime) {
                this.$set(
                  this.ruleForm.cooperInfoBO,
                  "foundTime",
                  result.data.data.cooperInfoBO.foundTime.slice(0, 10)
                );
              }
              this.ruleForm.supplierFinanceBO =
                result.data.data.supplierFinanceBO;
              result.data.data.supplierFileBOS.forEach((item) => {
                // item.isLongValidity = item.isLongValidity === 0 ? false : true;
                if (item.isLongValidity === 0) {
                  item.isLongValidity = false;
                } else {
                  item.isLongValidity = true;
                }
                if (item.fJName) {
                  if (item.fJName.indexOf("xls") !== -1) {
                    item.fileAddress =
                      "data:image/png;base64,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";
                  } else if (item.fJName.indexOf("doc") !== -1) {
                    item.fileAddress =
                      "data:image/png;base64,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";
                  } else if (item.fJName.indexOf("pdf") !== -1) {
                    item.fileAddress =
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
                  }
                }
              });

              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 1
                ) >= 0
              ) {
                this.fileList = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 1
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 1
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 1
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 1
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 1
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 1
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 1
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 2
                ) >= 0
              ) {
                this.fileList1 = [
                  {
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 2
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 2
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 2
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 2
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 2
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 2
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 3
                ) >= 0
              ) {
                this.fileList2 = [
                  {
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 3
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 3
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }

              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 4
                ) >= 0
              ) {
                this.fileList3 = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 4
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 4
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 4
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 5
                ) >= 0
              ) {
                this.fileList4 = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 5
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 5
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 5
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }
              if (
                result.data.data.supplierFileBOS.findIndex(
                  (item) => item.fileType === 7
                ) >= 0
              ) {
                this.fileList6 = [
                  {
                    name:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 7
                        )
                      ].fileName,
                    url:
                      result.data.data.supplierFileBOS[
                        result.data.data.supplierFileBOS.findIndex(
                          (item) => item.fileType === 7
                        )
                      ].fileAddress,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileClass,
                          fileName:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileClass,
                          downloadUrl:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileAddress,
                          fileType:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].fileType,
                          uploadId:
                            result.data.data.supplierFileBOS[
                              result.data.data.supplierFileBOS.findIndex(
                                (item) => item.fileType === 7
                              )
                            ].uploadId,
                        },
                      ],
                    },
                  },
                ];
              }

              for (let fileIdxE = 0; fileIdxE <= 1; fileIdxE++) {
                this.ruleForm.supplierFileBOS[fileIdxE].fileAddress =
                  result.data.data.supplierFileBOS[fileIdxE].fileAddress;
                this.ruleForm.supplierFileBOS[fileIdxE].fileName =
                  result.data.data.supplierFileBOS[fileIdxE].fileName;
                this.ruleForm.supplierFileBOS[fileIdxE].fileSize =
                  result.data.data.supplierFileBOS[fileIdxE].fileSize;
                this.ruleForm.supplierFileBOS[fileIdxE].fileType =
                  result.data.data.supplierFileBOS[fileIdxE].fileType;
                this.ruleForm.supplierFileBOS[fileIdxE].uploadId =
                  result.data.data.supplierFileBOS[fileIdxE].uploadId;
              }
              for (
                let fileIdxe = 2;
                fileIdxe <= result.data.data.supplierFileBOS.length - 1;
                fileIdxe++
              ) {
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileAddress =
                  result.data.data.supplierFileBOS[fileIdxe].fileAddress;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileName =
                  result.data.data.supplierFileBOS[fileIdxe].fileName;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileSize =
                  result.data.data.supplierFileBOS[fileIdxe].fileSize;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].fileType =
                  result.data.data.supplierFileBOS[fileIdxe].fileType;
                this.ruleForm.supplierFileBOS[fileIdxe + 1].uploadId =
                  result.data.data.supplierFileBOS[fileIdxe].uploadId;
              }
              this.ruleForm.supplierFileBOS[0].validityStart =
                result.data.data.supplierFileBOS[
                  result.data.data.supplierFileBOS.findIndex(
                    (item) => item.fileType === 1
                  )
                ].validityStart;
              this.ruleForm.supplierFileBOS[0].validityEnd =
                result.data.data.supplierFileBOS[
                  result.data.data.supplierFileBOS.findIndex(
                    (item) => item.fileType === 1
                  )
                ].validityEnd;
              this.ruleForm.supplierFileBOS[0].isLongValidity =
                result.data.data.supplierFileBOS[
                  result.data.data.supplierFileBOS.findIndex(
                    (item) => item.fileType === 1
                  )
                ].isLongValidity;
              if (
                result.data.data.supplierFileBOS[
                  result.data.data.supplierFileBOS.findIndex(
                    (item) => item.fileType === 7
                  )
                ]
              ) {
                this.ruleForm.supplierFileBOS[5].validityStart =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 7
                    )
                  ].validityStart;
                this.ruleForm.supplierFileBOS[5].validityEnd =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 7
                    )
                  ].validityEnd;
                this.ruleForm.supplierFileBOS[5].isLongValidity =
                  result.data.data.supplierFileBOS[
                    result.data.data.supplierFileBOS.findIndex(
                      (item) => item.fileType === 7
                    )
                  ].isLongValidity;
              }
              if (result.data.data.cooperInfoBO.unifiedCode) {
                this.taxFile = false;
                this.rules.regNum = [];
                this.rules.orgCode = [];
                this.rules.taxCode = [];
              } else {
                this.taxFile = true;
                this.rules.unifiedCode = [];
                this.$refs.unifiedCode.clearValidate();
                this.ruleForm.supplierFileBOS[5].fileAddress =
                  result.data.data.supplierFileBOS[4].fileAddress;
                this.ruleForm.supplierFileBOS[5].fileName =
                  result.data.data.supplierFileBOS[4].fileName;
                this.ruleForm.supplierFileBOS[5].fileSize =
                  result.data.data.supplierFileBOS[4].fileSize;
                this.ruleForm.supplierFileBOS[5].fileType =
                  result.data.data.supplierFileBOS[4].fileType;
                this.ruleForm.supplierFileBOS[5].uploadId =
                  result.data.data.supplierFileBOS[4].uploadId;
              }
            }
          });
        }
      }
      console.log(this.ruleForm.supplierFileBOS, "--附件");
    });
    this.$eventBus.$on("supplierName", (result) => {
      console.log(result, "查看ID");
      this.ruleForm.contactId = result.contactId;
      getCompany({
        mobile: result.mobile,
        supplierName: result.supplierName,
        // supplierName: "北京国际信托有限公司",
        isShowLoading: true,
      }).then((res) => {
        if (res.status === 200) {
          this.sID = res.data.data.sID;
          if (res.data.data.sID) {
            this.isSid = true;
          }
          if (res.data.data.bankId != "") {
            this.showInfoModal = true;
          } else {
            this.perfectInfoShow = true;
          }
          console.log(res, "公司详情");
          for (const i in res.data.data) {
            if (res.data.data[i]) {
              // console.log(res.data.data[i], "查询字段都有多少");
              this.ruleForm.cooperInfoBO[i] = res.data.data[i];
              switch (i) {
                case "businessAddress":
                  this.ruleForm.cooperInfoBO["officeAddress"] =
                    res.data.data[i];
                  break;
                case "supplierShortName":
                  this.ruleForm.cooperInfoBO["supplierShortname"] =
                    res.data.data[i];
                  break;
                case "taxNumber":
                  this.ruleForm.cooperInfoBO["taxCode"] = res.data.data[i];
                  break;
                case "legalPerson":
                  this.ruleForm.legalContactBO["contactName"] =
                    res.data.data[i];
                  break;
                case "bankName":
                  this.ruleForm.supplierFinanceBO["bankName"] =
                    res.data.data[i];
                  break;
                case "bankId":
                  this.ruleForm.supplierFinanceBO["bankId"] = res.data.data[i];
                  break;
                case "creditCode":
                  this.ruleForm.cooperInfoBO["unifiedCode"] = res.data.data[i];
                  break;
                case "compType":
                  this.ruleForm.cooperInfoBO["compType"] = res.data.data[i];
                  break;
                case "regLocation":
                  this.ruleForm.cooperInfoBO["address"] = res.data.data[i];
                  break;
                case "compType":
                  this.ruleForm.cooperInfoBO["compType"] = res.data.data[i];
                  break;
                case "compTypeName":
                  this.ruleForm.cooperInfoBO["compTypeName"] = res.data.data[i];
                  break;
                case "compClassName":
                  this.ruleForm.cooperInfoBO["compClassName"] =
                    res.data.data[i];
                  break;
                case "compClass":
                  this.ruleForm.cooperInfoBO["compClass"] = res.data.data[i];
                  break;
              }
              if (
                res.data.data.licenseFilePath &&
                res.data.data.licenseUploadId
              ) {
                this.fileList = [
                  {
                    name: res.data.data.licenseFileName,
                    url: res.data.data.licenseFilePath,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview: res.data.data.licensefileClass,
                          fileName: res.data.data.licenseName,
                          downloadUrl: res.data.data.licenseFilePath,
                          uploadId: res.data.data.licenseUploadId,
                          fileType: 1,
                        },
                      ],
                    },
                  },
                ];
                this.ruleForm.supplierFileBOS[0]["uploadId"] =
                  res.data.data.licenseUploadId;
                this.ruleForm.supplierFileBOS[0]["fileName"] =
                  res.data.data.licenseName;
                this.ruleForm.supplierFileBOS[0]["fileAddress"] =
                  res.data.data.licenseFilePath;
                this.ruleForm.supplierFileBOS[0]["fileType"] = 1;
                console.log(res.data.data.licenseFileName.indexOf("pdf"));
                if (res.data.data.licenseFileName.indexOf("xls") !== -1) {
                  this.fileList[0].url =
                    "data:image/png;base64,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";
                } else if (
                  res.data.data.licenseFileName.indexOf("doc") !== -1
                ) {
                  this.fileList[0].url =
                    "data:image/png;base64,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";
                } else if (
                  res.data.data.licenseFileName.indexOf("pdf") !== -1
                ) {
                  this.fileList[0].url =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
                }
              }
              if (res.data.data.authUploadId && res.data.data.authFilePath) {
                this.fileList1 = [
                  {
                    name: res.data.data.authFileName,
                    url: res.data.data.authFilePath,
                    percentage: 100,
                    response: {
                      data: [
                        {
                          filePreview: res.data.data.authfileClass,
                          fileName: res.data.data.authName,
                          downloadUrl: res.data.data.authFilePath,
                          uploadId: res.data.data.authUploadId,
                          fileType: 2,
                        },
                      ],
                    },
                  },
                ];
                this.ruleForm.supplierFileBOS[1]["uploadId"] =
                  res.data.data.authUploadId;
                this.ruleForm.supplierFileBOS[1]["fileName"] =
                  res.data.data.authName;
                this.ruleForm.supplierFileBOS[1]["fileAddress"] =
                  res.data.data.authFilePath;
                this.ruleForm.supplierFileBOS[1]["fileType"] = 2;
                if (res.data.data.authFileName.indexOf("xls") !== -1) {
                  this.fileList1[0].url =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAHFElEQVR4Xu2ceVATVxzHv0m4UVS8QEXxPloPrDqKFs8WtaLWiorXROXwQgUPVC5BW8cTFCuJ1qPeUnW0ioq2eFKwU6mAonSgaq0HjiiBACIBOhtqysagG9+GbPHtP8yS3++X9/3M7/veZvcloqzcx9cA9AI99CXwxFJc3lmUlfu4XN9MGl9BoBzlPShAgm6gAAng0Q4khEcBUoA8ECAsQedACpCQAGE67UAKkJAAYTrtQAqQkABhOu1ACpCQAGE67cD/K8D4m0m4kJbEGn5Xx44Y28eVs6RdF47hzyd/seJH9hyMnm06c65BGmi0Dix69RKz5Cvw6MVTjQaxSISIaYHo2KzVO3UlZtxA6OHNrLj2TVoicvpySMSSd+bzFWA0gIyAWw8ysXD3apSV/3c/16GBHaK9w2BmYlqlxvyiAnhFB+G5UqGJMTc1Q7T3CjSrb8cXG051jAqQGeHO+KM4dDWWNdhxzsPgOcS9SgFrjm/Hz6mJrNd9h0+BW4+BnETzGWR0gKpSFXx3rEJWpbnsbVZO/OMGQg+xrdurTRes9JgPkUjEJxtOtYwOkBnlvacPMee7cJSoSjSDdmhgr7ZkZSvrsm4dq9qQzwyHba06nATzHSQIgIyoo0lxkJ87/FYr67Ju6Li56NuhO99cONcTDEBmIQnYuw4p9+7oXJV1Wde1Wz8sHDmds1hDBAoGICPuqSIHPrIQFBQXsay8dspizNkexlp17es2RLTPCliZWxqCC+eaggLIjPp8SgLWndjBElDX2ga5BXmsztwgXYqPHNpyFmqoQMEBZISGx3yLq3euV6nZo98ITBs0xlBM9KorSICKwnx4y0LwotKF8mtVbe1bYNP0QJhITPQSaqhgQQJkxF64eQ2rj8nf0C3zCUOrxg6G4qF3XcECDDu8BQkZyW8ImthvBKQCsS8zOEECPJeSgPVaC8lrkmKRGBULSBu9u8UQCYIDmK14Bh9ZKAorXcpoC7ev1xAy7zBYmlsYgoleNQUFUH0xvWctUu5naESYiCWYMcQd8nOHWMKGObnAz02ql1hDBAsK4JHEOGw7z/44N7X/KEzuPwqbY/fg1PWLLAZh433Rp72TIbhwrikYgBU3FMJQolJpBt/arjmiZgTDRCJBYfFL+MiCka3I0bxe15q5kbAS9axtOAvmO1AQAHXd0mKsu8UrhHXJ8vvddATsXc9i0LtdN4RPmMc3F871BAFwV/wxHLx6ijXo19bVVqLLygtGSDG8uwtn0XwGGh1g+oMs+Ktv65dpWTdI56cNXVa2NDNXPwZoYtuITzacahkV4MtXxZgpD2U9WGKsG+UZDGb+q+rQZeVOzVpjg3QZJGIxJ+F8BRkV4KbYPYjVWlmrsi4XK0sHfomJn7rxxYZTHaMB/DUzFUEHIlmDrFh1dVtXW40uKzPdu2lGINraO3ISz0eQUQDmFSrhLQtm3SDlYl1twcl307FUa1VmnqVs9QoF85izOg6jAKwOYdX1HhQgIWkKkAIkJECYTjuQAiQkQJhOO5ACJCRAmE47kAIkJECYTjuQAiQkQJhOO5ACJCRAmE47kA+Am+Nj6O/GvCfIuha1Boha+o+iAN8ToGvX3mMowPeEx6RRgATwKEBCeBQgBcgDAcISRpsDG9vYwq5O/TeGf/PvLJRW2uZBoq9v2654lp+LjCf3Scq8NddoAH0/G4fZg8ciO+85a4AjNvhDWVzIi+B9M8ORlJmGLT/9wEs9XUWMCtClvRPctyxjjUsiEqOOVS3kvSyAqrQUFqZmYDYPvSjIV8eZm5iiVaOm6vMnlfYKWplZoEUDOzzIyYby3+3BHyRAZhP5/lnhePTiGQJionB8/jpcy7qFlSd24BPHDpBNW4YcpQLN69thX8JpfHNyN1w6OCFqymLkKHPV00LQERmO/XYBNR7gAlcP5msCmg5Mf3gXIyMWqiHELowAc85041ebA1BSqsKZRZsQl5aEyLiD6NS0FdaOn4up8hXq/0fHH8XuK6fQr11XREuXwjl8hvpvjbbwoE494bljlQYgY1lFkVJ97jVgNJa5STEpOhiJmWkwk5ji9poYteWTK32js5ltI1wO3IZsxXOoypjtwSI0rdcQ7lFL4Td0Ys0GqGsOZODZWtvg9KJItY1VZaXw2BqI0rIypH59AEsOReFsWiJsLK3h5+qBnZdP4uJyGWZ/vwZXMm6o58zebTrj0u3rkE9fXrMBTnIeirNav33A2DB4tCeKS17Bb38ETvlvxJnUX7Dx7AEs+WIKhnZxxs5LP2JQpx5oWLse3CL8sW7CPHSwd8TBpDh8/nFv9ab0ybKQmj0HGuy6opoLG+0yppp1GuztKEBCtBQgBUhIgDCddiAfAJ2CJxfkFuRbEdb64NJNxJJy976Du4sWxUS1VBYpu31wBAgFW5hb3I+c4Jf8Dw9520clkqqmAAAAAElFTkSuQmCC";
                } else if (res.data.data.authFileName.indexOf("doc") !== -1) {
                  this.fileList1[0].url =
                    "data:image/png;base64,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";
                } else if (res.data.data.authFileName.indexOf("pdf") !== -1) {
                  this.fileList1[0].url =
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
                }
              }
              if (res.data.data.foundTime) {
                this.$set(
                  this.ruleForm.cooperInfoBO,
                  "foundTime",
                  res.data.data.foundTime.slice(0, 10)
                );
              }
            }
          }
          this.ruleForm.cooperInfoBO.taxpayerId = res.data.data.taxpayerType;
          if (res.data.data.creditCode) {
            this.taxFile = false;
            this.rules.regNum = [];
            this.rules.orgCode = [];
            this.rules.taxCode = [];
          } else {
            this.taxFile = true;
            // this.rules.unifiedCode = [];
            // this.$refs.unifiedCode.clearValidate();
          }
        }
        console.log(this.ruleForm.cooperInfoBO["foundTime"]);
      });
    });

    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
  },
  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
  },
  methods: {
    // 将护照和身份证小写转大小
    replaceUpper(val) {
      this.ruleForm.legalContactBO.idNumber = val.toUpperCase();
    },
    checkUpSupplierName() {
      this.ruleForm.cooperInfoBO.upSupplierName = this.ruleForm.cooperInfoBO.upSupplierName.replace(
        /[^\u4e00-\u9fa5\(\)\（\）]/g,
        ""
      );
    },
    checkSupplierName() {
      this.ruleForm.cooperInfoBO.supplierChineseName = this.ruleForm.cooperInfoBO.supplierChineseName.replace(
        /[^\u4e00-\u9fa5\(\)\（\）]/g,
        ""
      );
    },

    handleClose(done) {
      done();
    },
    checkFactCapl() {
      this.ruleForm.cooperInfoBO.factCapl = this.ruleForm.cooperInfoBO.factCapl
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3")
        .replace(/^\./g, "");
    },
    checkLastYear() {
      this.ruleForm.cooperInfoBO.lastYearTurnover = this.ruleForm.cooperInfoBO.lastYearTurnover
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3")
        .replace(/^\./g, "");
    },
    checkUnifiedCode() {
      this.ruleForm.cooperInfoBO.unifiedCode = this.ruleForm.cooperInfoBO.unifiedCode.replace(
        /[^0-9QWERTYUPADFGHJKLMNBCX]/g,
        ""
      );
    },
    checkRegNum() {
      this.ruleForm.cooperInfoBO.regNum = this.ruleForm.cooperInfoBO.regNum.replace(
        /[^\d]/g,
        ""
      );
    },
    checkOrgCode() {
      this.ruleForm.cooperInfoBO.orgCode = this.ruleForm.cooperInfoBO.orgCode.replace(
        /[^0-9QWERTYUPADFGHJKLMNBCX]/g,
        ""
      );
    },
    checkTaxCode() {
      this.ruleForm.cooperInfoBO.taxCode = this.ruleForm.cooperInfoBO.taxCode.replace(
        /[^0-9QWERTYUPADFGHJKLMNBCX]/g,
        ""
      );
    },
    //校验
    regNumber(name) {
      this.ruleForm.cooperInfoBO[name] = this.ruleForm.cooperInfoBO[
        name
      ].replace(/[^\d.]/g, "");
    },
    //注册资本校验
    regCapitalChange(event) {
      // console.log(event);
      let val = this.ruleForm.cooperInfoBO.regCapl;
      if (event.keyCode === 190) {
        let valSplit = val.split(".");
        if (valSplit[0].length === 10) {
          this.regCapital = "15";
        }
      } else {
        if (!val.includes(".")) {
          this.regCapital = "10";
        }
      }
      let valSplit = val.split(".");
      if (valSplit[1] && valSplit[1].length === 4) {
        this.regCapital = val.length;
      }
    },
    //实收资本校验
    factCapitalChange(event) {
      // console.log(event);
      let val = this.ruleForm.cooperInfoBO.factCapl;
      if (event.keyCode === 190) {
        let valSplit = val.split(".");
        if (valSplit[0].length === 10) {
          this.factCapital = "15";
        }
      } else {
        if (!val.includes(".")) {
          this.factCapital = "10";
        }
      }
      let valSplit = val.split(".");
      if (valSplit[1] && valSplit[1].length === 4) {
        this.factCapital = val.length;
      }
    },
    //上年营业额校验
    lastYearTurnoverChange(event) {
      // console.log(event);
      let val = this.ruleForm.cooperInfoBO.lastYearTurnover;
      if (event.keyCode === 190) {
        let valSplit = val.split(".");
        if (valSplit[0].length === 10) {
          this.lastYearTurnoverLength = "15";
        }
      } else {
        if (!val.includes(".")) {
          this.lastYearTurnoverLength = "10";
        }
      }
      let valSplit = val.split(".");
      if (valSplit[1] && valSplit[1].length === 4) {
        this.lastYearTurnoverLength = val.length;
      }
    },
    //转换日期
    parserDate(date) {
      let t = Date.parse(date);
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, "/")));
      }
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
      console.log(window.innerHeight, "高度");
    },
    agreeChange() {
      console.log(this.ruleForm.cooperInfoBO.isForeignTrade);
    },
    //查询字典接口纳税人类型
    visibleChangeTax() {
      getQryDictByCode({ code: "TAXPAYER_TYPE" }).then((res) => {
        // console.log(res, "查询字典接口纳税人类型");
        if (res.data.code === "0") {
          this.taxerList = res.data.data;
        }
      });
    },
    //查询字典接口公司类型
    visibleChangeGslx() {
      getQryDictByCode({ code: "GSLX" }).then((res) => {
        // console.log(res, "查询字典接口公司类型");
        if (res.data.code === "0") {
          this.codeList = res.data.data;
        }
      });
    },
    //查询字典接口币种
    visibleChangeMoney() {
      getQryDictByCode({ code: "MONEY_TYPE" }).then((res) => {
        // console.log(res, "查询字典接口币种");
        if (res.data.code === "0") {
          this.moneyList = res.data.data;
        }
      });
    },
    // 查询字典接口单位类别
    visibleChangeCompclass() {
      getQryDictByCode({ code: "COMPCLASS" }).then((res) => {
        // console.log(res, "查询字典接口单位类别");
        if (res.data.code === "0") {
          this.COMPCLASSList = res.data.data;
        }
      });
    },
    //查询字典接口证件类型
    visibleChangeIDTYPE() {
      getQryDictByCode({ code: "IDTYPE" }).then((res) => {
        // console.log(res, "查询字典接口证件类型");
        if (res.data.code === "0") {
          this.IDList = res.data.data;
        }
      });
    },

    beforeunloadHandler(e) {
      // e.returnValue;
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    unifiedCodeBlur() {
      if (
        /[0-9A-HJ-NPQRTUWXY]+$/g.test(this.ruleForm.cooperInfoBO.unifiedCode)
      ) {
        this.taxFile = false;
        this.$nextTick(() => {
          // console.log(this.rules, "打印规则");
          this.rules.regNum = [];
          this.rules.orgCode = [];
          this.rules.taxCode = [];
          this.$refs.regNum.clearValidate();
          this.$refs.orgCode.clearValidate();
          this.$refs.taxCode.clearValidate();
        });
      } else {
        this.taxFile = true;
        this.$nextTick(() => {
          this.rules.regNum = [];
          this.rules.orgCode = [];
          this.rules.taxCode = [];
          this.$refs.regNum.clearValidate();
          this.$refs.orgCode.clearValidate();
          this.$refs.taxCode.clearValidate();
        });
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum
      ) {
        this.rules.unifiedCode = [];
        this.$refs.unifiedCode.clearValidate();
      } else {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum &&
        this.ruleForm.cooperInfoBO.unifiedCode
      ) {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
    },
    regNumBlur() {
      if (/\d+$/.test(this.ruleForm.cooperInfoBO.regNum)) {
        this.regNumBlurInfo = true;
        if (
          this.ruleForm.cooperInfoBO.taxCode &&
          this.ruleForm.cooperInfoBO.orgCode &&
          this.ruleForm.cooperInfoBO.regNum
        ) {
          this.rules.unifiedCode = [];
          this.$refs.unifiedCode.clearValidate();
        } else {
          this.rules.unifiedCode = [];
          this.rules.unifiedCode.push(
            {
              required: true,
              message: "请输入统一社会信用代码",
              trigger: ["blur"],
            },
            // {
            //   min: 18,
            //   message: "长度在18个字符",
            //   trigger: ["blur"]
            // },
            {
              required: true,
              pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
              message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
              trigger: ["blur"],
            }
          );
        }
      } else {
        this.regNumBlurInfo = "";
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum
      ) {
        this.rules.unifiedCode = [];
        this.$refs.unifiedCode.clearValidate();
      } else {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum &&
        this.ruleForm.cooperInfoBO.unifiedCode
      ) {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
    },
    orgCodeBlur() {
      if (/[0-9A-HJ-NPQRTUWXY]+$/.test(this.ruleForm.cooperInfoBO.orgCode)) {
        this.orgCodeBlurInfo = true;
        if (
          this.ruleForm.cooperInfoBO.taxCode &&
          this.ruleForm.cooperInfoBO.orgCode &&
          this.ruleForm.cooperInfoBO.regNum
        ) {
          this.rules.unifiedCode = [];
          this.$refs.unifiedCode.clearValidate();
        } else {
          this.rules.unifiedCode = [];
          this.rules.unifiedCode.push(
            {
              required: true,
              message: "请输入统一社会信用代码",
              trigger: ["blur"],
            },
            // {
            //   min: 18,
            //   message: "长度在18个字符",
            //   trigger: ["blur"]
            // },
            {
              required: true,
              pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
              message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
              trigger: ["blur"],
            }
          );
        }
      } else {
        this.orgCodeBlurInfo = "";
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum
      ) {
        this.rules.unifiedCode = [];
        this.$refs.unifiedCode.clearValidate();
      } else {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum &&
        this.ruleForm.cooperInfoBO.unifiedCode
      ) {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
    },
    taxCodeBlur() {
      if (/[0-9A-HJ-NPQRTUWXY]+$/.test(this.ruleForm.cooperInfoBO.taxCode)) {
        this.taxCodeBlurInfo = true;
        if (
          this.ruleForm.cooperInfoBO.taxCode &&
          this.ruleForm.cooperInfoBO.orgCode &&
          this.ruleForm.cooperInfoBO.regNum
        ) {
          this.rules.unifiedCode = [];
          this.$refs.unifiedCode.clearValidate();
        } else {
          this.rules.unifiedCode = [];
          this.rules.unifiedCode.push(
            {
              required: true,
              message: "请输入统一社会信用代码",
              trigger: ["blur"],
            },
            // {
            //   min: 18,
            //   message: "长度在18个字符",
            //   trigger: ["blur"]
            // },
            {
              required: true,
              pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
              message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
              trigger: ["blur"],
            }
          );
        }
      } else {
        this.taxCodeBlurInfo = "";
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum
      ) {
        this.rules.unifiedCode = [];
        this.$refs.unifiedCode.clearValidate();
      } else {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
      if (
        this.ruleForm.cooperInfoBO.taxCode &&
        this.ruleForm.cooperInfoBO.orgCode &&
        this.ruleForm.cooperInfoBO.regNum &&
        this.ruleForm.cooperInfoBO.unifiedCode
      ) {
        this.rules.unifiedCode = [];
        this.rules.unifiedCode.push(
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"],
          },
          // {
          //   min: 18,
          //   message: "长度在18个字符",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入正确的统一社会信用代码(大写英文不含I/O/Z/S/V)",
            trigger: ["blur"],
          }
        );
      }
    },
    //测试纳税人类型
    changeSle(value) {
      // console.log(this.ruleForm.cooperInfoBO.taxpayerId, value, "asdfasdf");
      // this.ruleForm.cooperInfoBO.taxpayerId = value;
      this.$nextTick(function () {
        let taxerListobj = {};
        taxerListobj = this.taxerList.find((item) => {
          //这里的userList就是上面遍历的数据源
          return item.dicKey === value; //筛选出匹配数据
        });
        this.ruleForm.cooperInfoBO.taxpayerName = taxerListobj.dicValue;
        this.ruleForm.cooperInfoBO.taxpayerId = taxerListobj.dicKey;
      });
    },
    //选择公司类型
    changeCompany(value) {
      let codeListObj = {};
      codeListObj = this.codeList.find((item) => {
        return item.dicKey === value;
      });
      // console.log(moneyObj.dicValue);
      this.ruleForm.cooperInfoBO.compTypeName = codeListObj.dicValue;
      this.ruleForm.cooperInfoBO.compType = codeListObj.dicKey;
    },
    //选择单位类别
    changeCompClass(value) {
      let COMPCLASSListObj = {};
      COMPCLASSListObj = this.COMPCLASSList.find((item) => {
        return item.dicKey === value;
      });
      // console.log(moneyObj.dicValue);
      this.ruleForm.cooperInfoBO.compClassName = COMPCLASSListObj.dicValue;
      this.ruleForm.cooperInfoBO.compClass = COMPCLASSListObj.dicKey;
      // this.rule;
    },
    //选择币种
    changeMoney(value) {
      let moneyObj = {};
      moneyObj = this.moneyList.find((item) => {
        return item.dicKey === value;
      });
      // console.log(moneyObj.dicValue);
      this.ruleForm.cooperInfoBO.coinName = moneyObj.dicValue;
      this.ruleForm.cooperInfoBO.coin = moneyObj.dicKey;
      // console.log(this.ruleForm.cooperInfoBO.coin);
    },
    //选择证件类型
    changeIdType(value) {
      this.ruleForm.legalContactBO.idNumber = "";
      let IDListObj = {};
      IDListObj = this.IDList.find((item) => {
        return item.dicKey === value;
      });
      // console.log(moneyObj.dicValue);
      this.ruleForm.legalContactBO.idTypeName = IDListObj.dicValue;
      this.ruleForm.legalContactBO.idType = IDListObj.dicKey;
      // console.log(this.ruleForm.legalContactBO.idType);
      if (this.ruleForm.legalContactBO.idType === "1") {
        this.idLength = 18;
        this.rules.idNumber = [];
        this.rules.idNumber.push(
          { required: true, message: "请输入证件号码", trigger: "blur" },
          // {
          //   min: 15,
          //   max: 18,
          //   message: "请输入正确的身份证号码",
          //   trigger: ["blur"]
          // },
          {
            required: true,
            pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号码",
            trigger: ["blur"],
          }
        );
        // console.log(this.rules.idNumber);
      } else if (this.ruleForm.legalContactBO.idType === "4") {
        this.idLength = 9;
        this.rules.idNumber = [];
        this.rules.idNumber.push(
          { required: true, message: "请输入护照号码", trigger: "blur" },
          {
            min: 2,
            message: "请输入护照号码",
            trigger: ["blur"],
          },
          {
            required: true,
            // pattern: /(^E\d{8}$)|(^SE\d{7}$)|(^DE\d{7}$)|(^PE\d{7}$)/,
            pattern: /(^[A-Za-z0-9\(\)\（\）]{9}$)/,
            message: "请输入正确的护照号码",
            trigger: ["blur"],
          }
        );
        // console.log(this.rules.idNumber);
      }
    },
    //选择所在区域
    handleChange(value, label) {
      console.log(value);
      if (value) {
        if (value.length === 3) {
          this.ruleForm.cooperInfoBO.location = value[0].addressCode;
          this.ruleForm.cooperInfoBO.locationName = value[0].addressAbbr;
          this.ruleForm.cooperInfoBO.province = value[0].addressCode;
          this.ruleForm.cooperInfoBO.provinceName = value[0].addressAbbr;
          this.ruleForm.cooperInfoBO.city = value[1].addressCode;
          this.ruleForm.cooperInfoBO.cityName = value[1].addressAbbr;
          this.ruleForm.cooperInfoBO.county = value[2].addressCode;
          this.ruleForm.cooperInfoBO.countyName = value[2].addressAbbr;
          this.addressPlaceholder =
            this.ruleForm.cooperInfoBO.provinceName +
            " / " +
            this.ruleForm.cooperInfoBO.cityName +
            " / " +
            this.ruleForm.cooperInfoBO.countyName;
        } else if (value.length === 1) {
          this.ruleForm.cooperInfoBO.location = value[0].addressCode;
          this.ruleForm.cooperInfoBO.locationName = value[0].addressAbbr;
          this.ruleForm.cooperInfoBO.province = value[0].addressCode;
          this.ruleForm.cooperInfoBO.provinceName = value[0].addressAbbr;
          this.ruleForm.cooperInfoBO.city = "";
          this.ruleForm.cooperInfoBO.cityName = "";
          this.ruleForm.cooperInfoBO.county = "";
          this.ruleForm.cooperInfoBO.countyName = "";
          this.addressPlaceholder = this.ruleForm.cooperInfoBO.provinceName;
        }
      }
    },
    //查询所属集团（暂时废弃）
    getQueryUnInfoByName() {
      if (this.ruleForm.cooperInfoBO.upSupplierName) {
        getQueryUnInfoByName({
          supplierName: this.ruleForm.cooperInfoBO.upSupplierName,
        }).then((res) => {
          console.log(res, "所属集团");
          // if (!res.data.supplierId) {
          //   this.$message({
          //     message: "所属集团不存在",
          //     type: "warning",
          //     offset: this.messageHeight
          //   });
          // } else {
          //   this.ruleForm.cooperInfoBO.upSupplierId = res.data.supplierId;
          // }
        });
      }
    },

    clickUpload(data) {
      this.uploadIdx = data;
    },
    // 上传文件之前的钩子
    // beforeUploadPicture1(params) {
    //   const file = params.file;
    //   // if (
    //   //   !(
    //   //     file.type === "image/png" ||
    //   //     file.type === "image/gif" ||
    //   //     file.type === "image/jpg" ||
    //   //     file.type === "image/jpeg"
    //   //   )
    //   // ) {
    //   //   this.msgTip("warning", "请上传格式为png, gif, jpg, jpeg的图片");
    //   //   return;
    //   // }
    //   let size = file.size / 1024 / 1024 / 15;
    //   if (size > 1) {
    //     this.$message.warning(`文件大小必须小于15M`);
    //     return;
    //   }
    //   let fd = new FormData();
    //   fd.append("file", file); //传文件
    //   uploads(fd).then(res => {
    //     console.log(res, "文件上传结果");
    //     this.ruleForm.supplierFileBOS[this.uploadIdx].uploadId =
    //       res.data.data.uploadId;
    //     console.log(res, "文件上传测试1111111111");
    //     this.ruleForm.supplierFileBOS[this.uploadIdx].fileName =
    //       res.data.data.fileName;
    //     this.ruleForm.supplierFileBOS[this.uploadIdx].fileAddress =
    //       res.data.data.fileAddress;
    //     this.ruleForm.supplierFileBOS[this.uploadIdx].fileSize =
    //       res.data.data.fileSize;
    //     // this.imageUrl1 = res.voT.downloadUrl;
    //   });
    //   return false; //屏蔽了action的默认上传
    // },
    //添加资质
    addTravel() {
      this.cloneObj.push(1);
    },
    Previous() {
      this.$emit("PreviousInfo");
    },
    // handleRemove(file, fileList) {
    //   console.log(file, fileList);
    // },
    // handlePreview(file) {
    //   console.log(file);
    // },
    handlePictureCardPreview(file, fileList) {
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else if (file.response.data[0]) {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },
    //附件信息上传之前的钩子
    beforeAvatarUpload(file) {
      let fileNameBefore = file.name;
      let pos = fileNameBefore.lastIndexOf(".");
      let lastName = fileNameBefore.split(".").pop().toLowerCase();
      console.log(lastName);
      if (
        lastName === "jpg" ||
        lastName === "png" ||
        lastName === "jpeg" ||
        lastName === "gif" ||
        lastName === "xls" ||
        lastName === "xlsx" ||
        lastName === "doc" ||
        lastName === "docx" ||
        lastName === "pdf"
      ) {
      } else {
        // console.log(lastName !== 'jpg' )
        this.$message({
          message:
            "上传文件支持格式：.jpg .png .jpeg .gif 每个不超过5M，.xls .xlsx .doc .docx .pdf每个不超过15M",
          type: "error",
          offset: this.messageHeight,
        });
        return false;
      }
      // console.log("fileList2:", file);
      const isJPG = file.type === "image/jpeg";
      const isPDF = file.type === "application/pdf";
      const isGIF = file.type === "image/gif";
      const isLt5M = file.size / 1024 / 1024 < 5;
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (isJPG || isGIF) {
        if (!isLt5M) {
          this.$message({
            message: "上传图片大小不能超过 5MB!",
            type: "error",
            offset: this.messageHeight,
          });
          return false;
        }
      } else {
        if (!isLt15M) {
          this.$message({
            message: "上传文件大小不能超过 15MB!",
            type: "error",
            offset: this.messageHeight,
          });
          return false;
        }
      }
      return true;
    },

    // 附件信息上传
    changeFile(file, fileList) {
      // console.log("fileList:", file);
      this.fileList = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },

    // 删除附件信息
    onFileDelete(file) {
      // console.log(file);
      this.fileList.splice(file, 1);
      this.ruleForm.supplierFileBOS[0].uploadId = "";
    },

    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      // console.log(file);
      this.ruleForm.supplierFileBOS[0].uploadId = response.data[0].uploadId;
      this.ruleForm.supplierFileBOS[0].fileType = 1;
      this.ruleForm.supplierFileBOS[0].fileName = "营业执照副本";
      this.ruleForm.supplierFileBOS[0].fileAddress =
        response.data[0].downloadUrl;
      this.ruleForm.supplierFileBOS[0].fileSize = response.data[0].fileSize;
    },
    //附件上传失败的钩子
    fileError(response, file, fileList) {
      // console.log();
      this.fileList = [];
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight,
      });
    },
    // 附件信息成功的时触发
    handleSuccess1(response, file, fileList) {
      // console.log(response.data[0], "上传打印");
      // console.log("11111s", file);
      this.ruleForm.supplierFileBOS[1].uploadId = response.data[0].uploadId;
      this.ruleForm.supplierFileBOS[1].fileType = 2;
      this.ruleForm.supplierFileBOS[1].fileName = "法定代表人授权委托书";
      this.ruleForm.supplierFileBOS[1].fileAddress =
        response.data[0].downloadUrl;
      this.ruleForm.supplierFileBOS[1].fileSize = response.data[0].fileSize;
    },
    // 附件信息上传
    changeFile1(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList1 = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },

    // 删除附件信息
    onFileDelete1(file) {
      // console.log(file);
      this.fileList1.splice(file, 1);
      // console.log("fileList:", this.fileList);
      this.ruleForm.supplierFileBOS[1].uploadId = "";
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview1(file, fileList) {
      // console.log("aaa", file);
      // console.log("bbb", fileList);
      // console.log(file.response.data[0].fileType);
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else if (file.response.data[0]) {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },
    //附件上传失败的钩子
    fileError1(response, file, fileList) {
      // console.log();
      this.fileList1 = [];
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight,
      });
    },

    // 附件信息上传
    changeFile2(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList2 = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },

    // 删除附件信息
    onFileDelete2(file) {
      // console.log(file);
      this.fileList2.splice(file, 1);
      // console.log("fileList:", this.fileList);
      this.ruleForm.supplierFileBOS[2].uploadId = "";
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview2(file, fileList) {
      // console.log("aaa", file);
      // console.log("bbb", fileList);
      // console.log(file.response.data[0].fileType);
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else if (file.response.data[0]) {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },

    // 附件信息成功的时触发
    handleSuccess2(response, file, fileList) {
      console.log(this.fileList2);
      // console.log(response.data[0], "上传打印");
      // console.log(file);
      this.ruleForm.supplierFileBOS[2].uploadId = response.data[0].uploadId;
      this.ruleForm.supplierFileBOS[2].fileType = 3;
      this.ruleForm.supplierFileBOS[2].fileName = "法定代表人身份证";
      this.ruleForm.supplierFileBOS[2].fileAddress =
        response.data[0].downloadUrl;
      this.ruleForm.supplierFileBOS[2].fileSize = response.data[0].fileSize;
    },
    //附件上传失败的钩子
    fileError2(response, file, fileList) {
      // console.log();
      this.fileList2 = [];
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight,
      });
    },
    // 附件信息上传
    changeFile3(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList3 = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },

    // 删除附件信息
    onFileDelete3(file) {
      // console.log(file);
      this.fileList3.splice(file, 1);
      // console.log("fileList:", this.fileList);
      this.ruleForm.supplierFileBOS[3].uploadId = "";
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview3(file, fileList) {
      // console.log("aaa", file);
      // console.log("bbb", fileList);
      // console.log(file.response.data[0].fileType);
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else if (file.response.data[0]) {
        this.dialogVisible = true;
        this.dialogImageUrl = fileList[0].url;
      }
    },

    // 附件信息成功的时触发
    handleSuccess3(response, file, fileList) {
      // console.log(response.data[0], "上传打印");
      // console.log(file);
      this.ruleForm.supplierFileBOS[3].uploadId = response.data[0].uploadId;
      this.ruleForm.supplierFileBOS[3].fileType = 4;
      this.ruleForm.supplierFileBOS[3].fileName = "纳税人证明材料";
      this.ruleForm.supplierFileBOS[3].fileAddress =
        response.data[0].downloadUrl;
      this.ruleForm.supplierFileBOS[3].fileSize = response.data[0].fileSize;
    },
    //附件上传失败的钩子
    fileError3(response, file, fileList) {
      // console.log();
      this.fileList3 = [];
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight,
      });
    },
    // 附件信息上传
    changeFile4(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList4 = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAHFElEQVR4Xu2ceVATVxzHv0m4UVS8QEXxPloPrDqKFs8WtaLWiorXROXwQgUPVC5BW8cTFCuJ1qPeUnW0ioq2eFKwU6mAonSgaq0HjiiBACIBOhtqysagG9+GbPHtP8yS3++X9/3M7/veZvcloqzcx9cA9AI99CXwxFJc3lmUlfu4XN9MGl9BoBzlPShAgm6gAAng0Q4khEcBUoA8ECAsQedACpCQAGE67UAKkJAAYTrtQAqQkABhOu1ACpCQAGE67cD/K8D4m0m4kJbEGn5Xx44Y28eVs6RdF47hzyd/seJH9hyMnm06c65BGmi0Dix69RKz5Cvw6MVTjQaxSISIaYHo2KzVO3UlZtxA6OHNrLj2TVoicvpySMSSd+bzFWA0gIyAWw8ysXD3apSV/3c/16GBHaK9w2BmYlqlxvyiAnhFB+G5UqGJMTc1Q7T3CjSrb8cXG051jAqQGeHO+KM4dDWWNdhxzsPgOcS9SgFrjm/Hz6mJrNd9h0+BW4+BnETzGWR0gKpSFXx3rEJWpbnsbVZO/OMGQg+xrdurTRes9JgPkUjEJxtOtYwOkBnlvacPMee7cJSoSjSDdmhgr7ZkZSvrsm4dq9qQzwyHba06nATzHSQIgIyoo0lxkJ87/FYr67Ju6Li56NuhO99cONcTDEBmIQnYuw4p9+7oXJV1Wde1Wz8sHDmds1hDBAoGICPuqSIHPrIQFBQXsay8dspizNkexlp17es2RLTPCliZWxqCC+eaggLIjPp8SgLWndjBElDX2ga5BXmsztwgXYqPHNpyFmqoQMEBZISGx3yLq3euV6nZo98ITBs0xlBM9KorSICKwnx4y0LwotKF8mtVbe1bYNP0QJhITPQSaqhgQQJkxF64eQ2rj8nf0C3zCUOrxg6G4qF3XcECDDu8BQkZyW8ImthvBKQCsS8zOEECPJeSgPVaC8lrkmKRGBULSBu9u8UQCYIDmK14Bh9ZKAorXcpoC7ev1xAy7zBYmlsYgoleNQUFUH0xvWctUu5naESYiCWYMcQd8nOHWMKGObnAz02ql1hDBAsK4JHEOGw7z/44N7X/KEzuPwqbY/fg1PWLLAZh433Rp72TIbhwrikYgBU3FMJQolJpBt/arjmiZgTDRCJBYfFL+MiCka3I0bxe15q5kbAS9axtOAvmO1AQAHXd0mKsu8UrhHXJ8vvddATsXc9i0LtdN4RPmMc3F871BAFwV/wxHLx6ijXo19bVVqLLygtGSDG8uwtn0XwGGh1g+oMs+Ktv65dpWTdI56cNXVa2NDNXPwZoYtuITzacahkV4MtXxZgpD2U9WGKsG+UZDGb+q+rQZeVOzVpjg3QZJGIxJ+F8BRkV4KbYPYjVWlmrsi4XK0sHfomJn7rxxYZTHaMB/DUzFUEHIlmDrFh1dVtXW40uKzPdu2lGINraO3ISz0eQUQDmFSrhLQtm3SDlYl1twcl307FUa1VmnqVs9QoF85izOg6jAKwOYdX1HhQgIWkKkAIkJECYTjuQAiQkQJhOO5ACJCRAmE47kAIkJECYTjuQAiQkQJhOO5ACJCRAmE47kA+Am+Nj6O/GvCfIuha1Boha+o+iAN8ToGvX3mMowPeEx6RRgATwKEBCeBQgBcgDAcISRpsDG9vYwq5O/TeGf/PvLJRW2uZBoq9v2654lp+LjCf3Scq8NddoAH0/G4fZg8ciO+85a4AjNvhDWVzIi+B9M8ORlJmGLT/9wEs9XUWMCtClvRPctyxjjUsiEqOOVS3kvSyAqrQUFqZmYDYPvSjIV8eZm5iiVaOm6vMnlfYKWplZoEUDOzzIyYby3+3BHyRAZhP5/lnhePTiGQJionB8/jpcy7qFlSd24BPHDpBNW4YcpQLN69thX8JpfHNyN1w6OCFqymLkKHPV00LQERmO/XYBNR7gAlcP5msCmg5Mf3gXIyMWqiHELowAc85041ebA1BSqsKZRZsQl5aEyLiD6NS0FdaOn4up8hXq/0fHH8XuK6fQr11XREuXwjl8hvpvjbbwoE494bljlQYgY1lFkVJ97jVgNJa5STEpOhiJmWkwk5ji9poYteWTK32js5ltI1wO3IZsxXOoypjtwSI0rdcQ7lFL4Td0Ys0GqGsOZODZWtvg9KJItY1VZaXw2BqI0rIypH59AEsOReFsWiJsLK3h5+qBnZdP4uJyGWZ/vwZXMm6o58zebTrj0u3rkE9fXrMBTnIeirNav33A2DB4tCeKS17Bb38ETvlvxJnUX7Dx7AEs+WIKhnZxxs5LP2JQpx5oWLse3CL8sW7CPHSwd8TBpDh8/nFv9ab0ybKQmj0HGuy6opoLG+0yppp1GuztKEBCtBQgBUhIgDCddiAfAJ2CJxfkFuRbEdb64NJNxJJy976Du4sWxUS1VBYpu31wBAgFW5hb3I+c4Jf8Dw9520clkqqmAAAAAElFTkSuQmCC";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },

    // 删除附件信息
    onFileDelete4(file) {
      // console.log(file);
      this.fileList4.splice(file, 1);
      // console.log("fileList:", this.fileList);
      this.ruleForm.supplierFileBOS[4].uploadId = "";
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview4(file, fileList) {
      // console.log("aaa", file);
      // console.log("bbb", fileList);
      // console.log(file.response.data[0].fileType);
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else if (file.response.data[0]) {
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
      }
    },

    // 附件信息成功的时触发
    handleSuccess4(response, file, fileList) {
      // console.log(response.data[0], "上传打印");
      // console.log(fileList);
      //第二个文件
      if (response) {
        this.ruleForm.supplierFileBOS[4].uploadId =
          fileList[0].response.data[0].uploadId;
        this.ruleForm.supplierFileBOS[4].fileType = 5;
        this.ruleForm.supplierFileBOS[4].fileName = "税务登记证";
        this.ruleForm.supplierFileBOS[4].fileAddress =
          fileList[0].response.data[0].downloadUrl;
        this.ruleForm.supplierFileBOS[4].fileSize =
          fileList[0].response.data[0].fileSize;
      }
    },
    //附件上传失败的钩子
    fileError4(response, file, fileList) {
      // console.log();
      this.fileList4 = [];
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight,
      });
    },
    changeFile6(file, fileList) {
      // console.log("fileList:", fileList);
      this.fileList6 = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },

    // 删除附件信息
    onFileDelete6(file) {
      // console.log(file);
      this.fileList6.splice(file, 1);
      // console.log("fileList:", this.fileList);
      this.ruleForm.supplierFileBOS[5].uploadId = "";
    },

    // 点击已上传附件信息的时触发
    handlePictureCardPreview6(file, fileList) {
      // console.log("aaa", file);
      // console.log("bbb", fileList);
      // console.log(file.response.data[0].fileType);
      if (
        file.response.data[0].fileClass === 1 ||
        fileList[0].response.data[0].filePreview === 1
      ) {
        this.$message({
          message: "该文件类型不支持预览",
          type: "warning",
          offset: this.messageHeight,
        });
      } else if (file.response.data[0]) {
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
      }
    },

    // 附件信息成功的时触发
    handleSuccess6(response, file, fileList) {
      // console.log(response.data[0], "上传打印");
      // console.log(fileList);
      //第二个文件
      if (response) {
        this.ruleForm.supplierFileBOS[5].uploadId =
          fileList[0].response.data[0].uploadId;
        this.ruleForm.supplierFileBOS[5].fileType = 7;
        this.ruleForm.supplierFileBOS[5].fileName = "组织机构代码证";
        this.ruleForm.supplierFileBOS[5].fileAddress =
          fileList[0].response.data[0].downloadUrl;
        this.ruleForm.supplierFileBOS[5].fileSize =
          fileList[0].response.data[0].fileSize;
      }
    },
    //附件上传失败的钩子
    fileError6(response, file, fileList) {
      // console.log();
      this.fileList6 = [];
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight,
      });
    },
    //上传信息
    submitForm() {
      if (this.ruleForm.cooperInfoBO.supplierEnglishName) {
        this.ruleForm.cooperInfoBO.supplierEnglishName = this.ruleForm.cooperInfoBO.supplierEnglishName.replace(
          /[\u4e00-\u9fa5]/g,
          ""
        );
      }
      if (
        /[0-9A-HJ-NPQRTUWXY]+$/g.test(this.ruleForm.cooperInfoBO.unifiedCode)
      ) {
        this.taxFile = false;
      } else {
        this.taxFile = true;
      }
      if (this.ruleForm.cooperInfoBO.employeeNum) {
        if (typeof this.ruleForm.cooperInfoBO.employeeNum != "number") {
          this.ruleForm.cooperInfoBO.employeeNum = Number(
            this.ruleForm.cooperInfoBO.employeeNum.replace(/[^\d$]/g, "")
          );
        }
      }
      // if (this.ruleForm.cooperInfoBO.lastYearTurnover != "") {
      //   this.ruleForm.cooperInfoBO.lastYearTurnover =
      //     Math.round(
      //       Number(this.ruleForm.cooperInfoBO.lastYearTurnover) * 10000
      //     ) / 10000;
      // }
      this.ruleForm.cooperInfoBO.regSource = "2";
      if (sessionStorage.getItem("querySupplierCode")) {
        let codeObj = JSON.parse(sessionStorage.getItem("querySupplierCode"));
        this.ruleForm.supplierCode = codeObj.supplierCode;
        console.log(this.ruleForm.supplierCode);
      }
      let submitParams = JSON.parse(JSON.stringify(this.ruleForm));
      submitParams.supplierFileBOS.forEach((item) => {
        if (item.validityStart) {
          let startDate = new Date(item.validityStart);
          item.validityStart =
            startDate.getFullYear() +
            "-" +
            this.p(startDate.getMonth() + 1) +
            "-" +
            this.p(startDate.getDate());
        }
        if (item.validityEnd) {
          let endDate = new Date(item.validityEnd);
          item.validityEnd =
            endDate.getFullYear() +
            "-" +
            this.p(endDate.getMonth() + 1) +
            "-" +
            this.p(endDate.getDate());
        }
        if (item.foundTime) {
          let foundDate = new Date(item.foundTime);
          item.foundTime =
            foundDate.getFullYear() +
            "-" +
            this.p(foundDate.getMonth() + 1) +
            "-" +
            this.p(foundDate.getDate());
        }
        if (item.isLongValidity === true) {
          item.isLongValidity = 1;
        } else {
          console.log(item);
          item.isLongValidity = 0;
        }
      });
      if (this.ruleForm.cooperInfoBO.city != "" && this.addType === false) {
        this.ruleForm.cooperInfoBO.city2 = [
          { addressCode: this.ruleForm.cooperInfoBO.location },
          { addressCode: this.ruleForm.cooperInfoBO.province },
          { addressCode: this.ruleForm.cooperInfoBO.city },
          { addressCode: this.ruleForm.cooperInfoBO.county },
        ];
      }
      if (submitParams.cooperInfoBO.countyName != "") {
        let addressInputValue =
          submitParams.cooperInfoBO.provinceName +
          "/" +
          submitParams.cooperInfoBO.cityName +
          "/" +
          submitParams.cooperInfoBO.countyName;
        this.$refs.addressSel.$el.children[0].children[0].value = addressInputValue;
        this.$refs.addressSel.$el.children[0].children[0].value = addressInputValue;
      } else {
        let addressInputValue = submitParams.cooperInfoBO.provinceName;
        this.$refs.addressSel.$el.children[0].children[0].value = addressInputValue;
      }
      if (
        submitParams.cooperInfoBO.supplierShortname.split(" ").join("")
          .length === 0
      ) {
        this.ruleForm.cooperInfoBO.supplierShortname = "";
        submitParams.cooperInfoBO.supplierShortname = "";
      }
      if (submitParams.cooperInfoBO.address.split(" ").join("").length === 0) {
        this.ruleForm.cooperInfoBO.address = "";
        submitParams.cooperInfoBO.address = "";
      }
      if (
        submitParams.cooperInfoBO.supplierScope.split(" ").join("").length === 0
      ) {
        this.ruleForm.cooperInfoBO.supplierScope = "";
        submitParams.cooperInfoBO.supplierScope = "";
      }
      if (
        submitParams.supplierFinanceBO.bankName.split(" ").join("").length === 0
      ) {
        this.ruleForm.supplierFinanceBO.bankName = "";
        submitParams.supplierFinanceBO.bankName = "";
      }
      if (
        submitParams.supplierFinanceBO.billingAddress.split(" ").join("")
          .length === 0
      ) {
        this.ruleForm.supplierFinanceBO.billingAddress = "";
        submitParams.supplierFinanceBO.billingAddress = "";
      }
      let flag = true;
      let infoFlag = false;
      const isRuleForm = ["ruleForm", "ruleForm1", "ruleForm2"];
      isRuleForm.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (valid) {
            infoFlag = true;
          } else {
            flag = false;
            this.$nextTick(() => {
              const ele =
                this.$el.querySelector(".is-error") ||
                this.$el.querySelector(".is-required");
              console.log(ele);
              console.log(ele.offsetTop);
              if (ele) {
                // 获取到所在Row的offsetTop值
                window.scrollTo(
                  0,
                  ele.offsetTop ||
                    ele.parentNode.parentNode.parentNode.offsetTop
                );
              }
            });
            return false;
          }
        });
      });

      //s
      this.ruleForm.cooperInfoBO.supplierScope = this.ruleForm.cooperInfoBO.supplierScope.replace(
        /(^\s*\n*)|(\s*\n*$)/g,
        ""
      );
      if (
        this.ruleForm.cooperInfoBO.supplierScope.split(" ").join("").length ===
        0
      ) {
        // this.$message.warning("请输入经营范围");
        this.ruleForm.cooperInfoBO.supplierScope = "";
        this.$nextTick(() => {
          const ele =
            this.$el.querySelector(".is-error") ||
            this.$el.querySelector(".is-required");
          console.log(ele);
          console.log(ele.offsetTop);
          if (ele) {
            // 获取到所在Row的offsetTop值
            window.scrollTo(
              0,
              ele.offsetTop || ele.parentNode.parentNode.parentNode.offsetTop
            );
          }
        });
        return false;
      }
      this.ruleForm.supplierFinanceBO.billingAddress = this.ruleForm.supplierFinanceBO.billingAddress.replace(
        /[\s\r\n]/g,
        ""
      );
      if (
        this.ruleForm.supplierFinanceBO.billingAddress.split(" ").join("")
          .length === 0
      ) {
        // this.$message.warning("请输入开票地址");
        this.ruleForm.supplierFinanceBO.billingAddress = "";
        this.$nextTick(() => {
          const ele =
            this.$el.querySelector(".is-error") ||
            this.$el.querySelector(".is-required");
          console.log(ele);
          console.log(ele.offsetTop);
          if (ele) {
            // 获取到所在Row的offsetTop值
            window.scrollTo(
              0,
              ele.offsetTop || ele.parentNode.parentNode.parentNode.offsetTop
            );
          }
        });
        return false;
      }
      //e
      if (submitParams.supplierFinanceBO.billingTelephone === "") {
        return false;
      }
      let requireEle =
        this.$el.querySelector(".is-error") ||
        this.$el.querySelector(".is-required");
      if (requireEle) {
        if (
          requireEle.className === "el-form-item remarkItem is-required" ||
          requireEle.className ===
            "el-form-item remarkItem is-success is-required"
        ) {
          console.log("进来");
        } else {
          console.log(requireEle.className);
          console.log(requireEle);
          window.scrollTo(
            0,
            requireEle.offsetTop ||
              requireEle.parentNode.parentNode.parentNode.offsetTop
          );
          return false;
        }
      }

      // //上传接口调试好后打开
      let listFlag = true;
      submitParams.supplierFileBOS.map((v) => {
        if (!v.uploadId) {
          listFlag = false;
        }
      });
      if (this.taxFile === true) {
        let newFileArr = [];
        submitParams.supplierFileBOS.forEach((keys, keyIndex) => {
          if (keys.uploadId) {
            newFileArr.push(keys);
            // console.log(newFileArr);
          }
        });
        submitParams.supplierFileBOS = newFileArr;
        // console.log(submitParams.supplierFileBOS, "最后操作数组");
        if (submitParams.supplierFileBOS.length <= 3) {
          if (submitParams.supplierFileBOS.length < 3) {
            listFlag = false;
          } else {
            for (let fileIdx = 0; fileIdx < 3; fileIdx++) {
              if (submitParams.supplierFileBOS[fileIdx].uploadId != "") {
                listFlag = true;
              }
            }
            submitParams.supplierFileBOS.splice(3, 5);
          }
        } else {
          let fileIdxAfterNum = 0;
          if (submitParams.supplierFileBOS[3]) {
            if (submitParams.supplierFileBOS[3].uploadId) {
              fileIdxAfterNum = 4;
            }
          }
          if (submitParams.supplierFileBOS[4]) {
            if (submitParams.supplierFileBOS[4].uploadId) {
              fileIdxAfterNum = 5;
            }
          }
          if (submitParams.supplierFileBOS[5]) {
            if (submitParams.supplierFileBOS[5].uploadId) {
              fileIdxAfterNum = 6;
            }
          }
          if (submitParams.supplierFileBOS[6]) {
            if (submitParams.supplierFileBOS[6].uploadId) {
              fileIdxAfterNum = 7;
            }
          }
          if (submitParams.supplierFileBOS[7]) {
            if (submitParams.supplierFileBOS[7].uploadId) {
              fileIdxAfterNum = 8;
            }
          }
          listFlag = true;
          // submitParams.supplierFileBOS.splice(
          //   fileIdxAfterNum,
          //   8 - fileIdxAfterNum
          // );
        }
      }
      if (this.taxFile === false) {
        let newFileArr = [];
        console.log(submitParams.supplierFileBOS, "重新赋值之前的文件");
        submitParams.supplierFileBOS.forEach((keys, keyIndex) => {
          if (keys.uploadId) {
            newFileArr.push(keys);
            // console.log(newFileArr);
          }
        });
        submitParams.supplierFileBOS = newFileArr;
      }
      console.log(submitParams.supplierFileBOS, "附件赋值");
      let listTwoFlag = true;
      if (this.taxFile === true) {
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 1
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 2
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 3
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 4
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 5
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 7
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
      }
      if (this.taxFile === false) {
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 1
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 2
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 3
          ) >= 0
        ) {
          listFlag = true;
        } else {
          listFlag = false;
          listTwoFlag = false;
        }
      }
      if (!listTwoFlag) {
        this.$message({
          message: "请将文件全部上传",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }

      if (listFlag === false) {
        this.$message({
          message: "请将文件全部上传",
          type: "warning",
          offset: this.messageHeight,
        });
        return false;
      }

      console.log(submitParams.supplierFileBOS, "处理过的附件");
      if (this.taxFile === false) {
        if (!submitParams.supplierFileBOS[0].validityStart) {
          this.$message({
            message: "请选择营业执照副本有效期",
            type: "warning",
            offset: this.messageHeight,
          });
          return false;
        }
        if (submitParams.supplierFileBOS[0].isLongValidity != 1) {
          console.log("jinru");
          if (!submitParams.supplierFileBOS[0].validityEnd) {
            this.$message({
              message: "请选择营业执照副本有效期结束时间",
              type: "warning",
              offset: this.messageHeight,
            });
            return false;
          }
        }
        if (
          submitParams.supplierFileBOS.findIndex(
            (item) => item.fileType === 7
          ) >= 0
        ) {
          if (
            submitParams.supplierFileBOS[
              submitParams.supplierFileBOS.findIndex(
                (item) => item.fileType === 7
              )
            ].validityStart
          ) {
            if (
              submitParams.supplierFileBOS[
                submitParams.supplierFileBOS.findIndex(
                  (item) => item.fileType === 7
                )
              ].isLongValidity !== 1
            ) {
              if (
                !submitParams.supplierFileBOS[
                  submitParams.supplierFileBOS.findIndex(
                    (item) => item.fileType === 7
                  )
                ].validityEnd
              ) {
                this.$message({
                  message: "请选择组织机构代码证有效期结束时间",
                  type: "warning",
                  offset: this.messageHeight,
                });
                return false;
              }
            }
          }
        }
      } else {
        if (!submitParams.supplierFileBOS[0].validityStart) {
          this.$message({
            message: "请选择营业执照副本有效期",
            type: "warning",
            offset: this.messageHeight,
          });
          return false;
        } else if (submitParams.supplierFileBOS[0].isLongValidity != 1) {
          console.log("jinru");
          if (!submitParams.supplierFileBOS[0].validityEnd) {
            this.$message({
              message: "请选择营业执照副本有效期结束时间",
              type: "warning",
              offset: this.messageHeight,
            });
            return false;
          }
        } else if (!submitParams.supplierFileBOS[5].validityStart) {
          this.$message({
            message: "请选择组织机构代码证有效期",
            type: "warning",
            offset: this.messageHeight,
          });
          return false;
        } else if (submitParams.supplierFileBOS[5].isLongValidity !== 1) {
          if (!submitParams.supplierFileBOS[5].validityEnd) {
            this.$message({
              message: "请选择组织机构代码证有效期结束时间",
              type: "warning",
              offset: this.messageHeight,
            });
            return false;
          }
        }
      }

      console.log(submitParams, this.$refs.children, "上传文件的");
      setTimeout(() => {
        if (flag && listFlag) {
          if (flag) {
            this.perfectDisabled = true;
            submitParams.cooperInfoBO["sID"] = this.sID;
            submitParams.isShowLoading = true;
            submitParams.loadingMessage = "保存中,请稍等...";
            //去除基本信息首尾空格、tab、回车键
            for (const key in submitParams.cooperInfoBO) {
              if (submitParams.cooperInfoBO[key]) {
                // console.log(key, "查询字段都有多少");
                switch (key) {
                  case "supplierChineseName":
                    submitParams.cooperInfoBO[
                      "supplierChineseName"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "supplierEnglishName":
                    submitParams.cooperInfoBO[
                      "supplierEnglishName"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "supplierShortname":
                    submitParams.cooperInfoBO[
                      "supplierShortname"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "address":
                    submitParams.cooperInfoBO[
                      "address"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "supplierScope":
                    submitParams.cooperInfoBO[
                      "supplierScope"
                    ] = submitParams.cooperInfoBO[key].replace(
                      /(^\s*\n*)|(\s*\n*$)/g,
                      ""
                    );
                    break;
                  case "officeAddress":
                    submitParams.cooperInfoBO[
                      "officeAddress"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "post":
                    submitParams.cooperInfoBO[
                      "post"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "upSupplierName":
                    submitParams.cooperInfoBO[
                      "upSupplierName"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "website":
                    submitParams.cooperInfoBO[
                      "website"
                    ] = submitParams.cooperInfoBO[key].replace(/\s+/g, "");
                    break;
                  case "corpDesc":
                    submitParams.cooperInfoBO[
                      "corpDesc"
                    ] = submitParams.cooperInfoBO[key].replace(
                      /(^\s*\n*)|(\s*\n*$)/g,
                      ""
                    );
                    break;
                  case "orgDesc":
                    submitParams.cooperInfoBO[
                      "orgDesc"
                    ] = submitParams.cooperInfoBO[key].replace(
                      /(^\s*\n*)|(\s*\n*$)/g,
                      ""
                    );
                    break;
                }
              }
            }
            //去除法人信息收尾空格、tab、回车键
            for (const keyLegal in submitParams.legalContactBO) {
              if (submitParams.legalContactBO[keyLegal]) {
                // console.log(keyLegal, "查询字段都有多少");
                switch (keyLegal) {
                  case "contactTel":
                    submitParams.legalContactBO[
                      "contactTel"
                    ] = submitParams.legalContactBO[keyLegal].replace(
                      /\s+/g,
                      ""
                    );
                    break;
                }
              }
            }
            //去除银行信息收尾空格、tab、回车键
            for (const keyFinance in submitParams.supplierFinanceBO) {
              if (submitParams.supplierFinanceBO[keyFinance]) {
                // console.log(keyFinance, "查询字段都有多少");
                switch (keyFinance) {
                  case "bankName":
                    submitParams.supplierFinanceBO[
                      "bankName"
                    ] = submitParams.supplierFinanceBO[keyFinance].replace(
                      /\s+/g,
                      ""
                    );
                    break;
                  case "billingAddress":
                    submitParams.supplierFinanceBO[
                      "billingAddress"
                    ] = submitParams.supplierFinanceBO[keyFinance].replace(
                      /\s+/g,
                      ""
                    );
                    break;
                }
              }
            }
            console.log(submitParams);
            setTimeout(() => {
              this.perfectDisabled = false;
            }, 2000);
            getSaveSupplierInfo(submitParams).then((res) => {
              if (res.data.code === "0") {
                // if (res.data.data.point) {
                //   this.$message({
                //     message: res.data.data.point,
                //     type: "warning",
                //     offset: document.body.clientHeight / 2 - 21
                //   });
                //   return false
                // }
                if (this.ruleForm.cooperInfoBO.supplierCode) {
                  this.$eventBus.$emit(
                    "supplierCode",
                    this.ruleForm.cooperInfoBO.supplierCode
                  );
                } else {
                  this.$eventBus.$emit("supplierCode", res.data.data);
                }
                // this.fileList2 = [];
                // this.ruleForm.supplierFileBOS[2] = {};
                // submitParams.supplierFileBOS.splice(2, 1);
                this.$emit("nextPerfectInfo");
              } else {
                this.perfectDisabled = false;
              }
            });
          }
        }
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.remarkItem {
  position: relative;
  span {
    position: absolute;
    right: -286px;
    width: 266px;
  }
  .nameTipCenter {
    top: 7px;
  }
}
.perfectingInformation {
  margin: 0 auto;
  .detailedInformation {
    // width: 92.1%;
    // min-width: 1180px;
    width: 1180px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    background: rgba(255, 255, 255, 1);
    // padding-bottom: 26px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // padding-left: 154px;
    .el-card-title {
      /deep/ .details-title {
        color: rgba(255, 20, 47, 1);
        border-bottom: 2px solid rgba(255, 20, 47, 1);
        margin-left: 20px;
      }
    }
    .el-form {
      .el-form-item {
        margin: 20px 0 0 45px;
        // color: rgba(208, 2, 27, 1);

        .format {
          font-size: 13px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: rgba(155, 155, 155, 1);
          line-height: 17px;
        }
        /deep/ .el-form-item__label {
          padding: 1px 2px 0 0;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
        }
        /deep/ .el-form-item__content {
          .input-long {
            width: 430px;
          }
          .input-short {
            width: 430px;
          }
          .el-input__inner {
            width: 430px;
          }
          .el-textarea {
            font-size: 13px;
            width: 430px;
            height: 70px;
            color: rgba(74, 74, 74, 1);
            font-family: PingFangSC-Regular, PingFangSC;
            font-weight: 400;
            line-height: 17px;
            &:-ms-input-placeholder {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(155, 155, 155, 1);
            }
          }
          // .textarea-long {
          //   width: 100%;
          //   height: 66px;
          //   .el-textarea__inner {
          //     width: 430px;
          //     height: 66px !important;
          //     background: #fff;
          //     // padding-left: 10px;
          //     font-size: 13px;
          //     font-family: PingFangSC-Regular, PingFang SC;
          //     font-weight: 400;
          //     line-height: 17px;
          //     &:-ms-input-placeholder {
          //       font-size: 13px;
          //       font-family: PingFangSC-Regular, PingFang SC;
          //       font-weight: 400;
          //       color: rgba(155, 155, 155, 1);
          //     }
          //   }
          // }
        }
      }
    }
  }
  .footer {
    margin-left: 390px;
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: center;
    .left-btn {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      margin-right: 20px;
      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
    .right-btn {
      width: 400px;
      height: 40px;
      border-radius: 4px;
      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
  }
}

.nameTip,
.codeTip1,
.codeTip2 {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 15px;
}
.el-radio:nth-child(2) {
  margin-left: 30px;
}
.footer .btn {
  background-color: rgba(255, 20, 47, 1);
  border-color: rgba(255, 20, 47, 1);
}

.uploadInfo {
  padding-top: 17px;
  position: relative;
}
.safe {
  width: 800px;
  margin-bottom: 16px;
}
.safe .text {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 48px;
}
.licenseWebsite {
  margin-left: 56px;
}
.demonstration {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 119px;
}
.block {
  margin-top: 20px;
  position: relative;
}

.mustInfoY {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -66px;
  top: 2px;
  font-size: 14px;
  display: inline;
}
.mustInfo {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -130px;
  top: 0px;
  font-size: 14px;
  display: inline;
}
.mustInfoT {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -104px;
  top: 2px;
  font-size: 14px;
  display: inline;
}
.mustInfoG {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -90px;
  top: 2px;
  font-size: 14px;
  display: inline;
}
.mustInfoS {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -78px;
  top: 0px;
  font-size: 14px;
  display: inline;
}
.regNum::before {
  left: 43px;
}
.orgCode::before {
  left: 32px;
}
.taxCode::before {
  left: 32px;
}
.el-date-editor--date {
  width: 140px;
  height: 30px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}
/deep/.checkBox {
  margin-left: 28px;
  /deep/.el-checkbox__label {
    position: relative;
    top: 1px;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar-uploader {
  width: 80px;
  height: 80px;
  padding-bottom: 24px;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
.commonTxt {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 6px;
  margin-top: 10px;
}
.commonTxtTip {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ff142f;
  line-height: 6px;
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 10px;
}
.commonTxt a {
  color: rgba(0, 137, 239, 1);
  cursor: pointer;
}
.lastYearTurnoverTxt {
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
.addBox {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 20, 47, 1);
  line-height: 18px;
  margin-left: 50px;
  margin-top: 10px;
  cursor: pointer;
  width: 20%;
}
.intelligence {
  margin-left: 94px;
}
.companyInfoTxt {
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}
.el-card-title {
  margin-top: 20px;
}
.website {
  margin: 20px 0 0 54px !important;
}
.scanFile3 {
  padding-left: 68px;
}
/deep/.el-input__inner {
  padding: 0 10px !important;
}
/deep/.el-textarea__inner {
  padding: 5px 10px !important;
  min-height: 64px !important;
}
/deep/ .el-table__header-wrapper .has-gutter th:nth-child(2):before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: 0;
  top: 14px;
  font-size: 14px;
}
/deep/ .el-table__header-wrapper .has-gutter th:nth-child(3):before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: 0;
  top: 14px;
  font-size: 14px;
}

/deep/ .checkClass {
  position: relative;
  input::-webkit-input-placeholder {
    color: #4a4a4a;
  }
  input::-moz-input-placeholder {
    color: #4a4a4a;
  }
  input::-ms-input-placeholder {
    color: #4a4a4a;
  }
}

/deep/.checkClassRules {
  position: relative;
}
</style>
<style>
.el-radio__input.is-checked .el-radio__inner {
  background-color: rgba(59, 136, 253, 1);
  border-color: rgba(59, 136, 253, 1);
}
.el-radio__input.is-checked + .el-radio__label {
  color: rgba(74, 74, 74, 1);
}
.el-radio__inner:hover {
  border: 1px solid rgba(59, 136, 253, 1);
}
.el-radio__label {
  width: 65px;
  height: 17px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 17px;
}
.el-select-dropdown__item span {
  padding-left: 9px;
}

.el-upload--picture-card {
  width: 80px;
  height: 80px;
  padding-bottom: 24px;
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.el-input__inner,
.el-select,
.el-cascader {
  width: 430px;
}
.selectDate input {
  padding: 0 26px !important;
}

.el-file-upload .file .file-list {
  margin: 0 !important  ;
}
.el-file-upload .file .file-list li {
  margin-right: 18px !important;
}
</style>
